import React from "react";
import { Link } from "react-router";
import ReactDataSheet from "react-datasheet";
import Select from "react-select";
import {
  san_jose_schedule,
  san_joaquin_schedule,
  san_jose_type,
  san_joaquin_type,
  san_juan_type,
  san_jose_2_type,
} from "./schedules.js";
import {
  year_2018_proportions_new,
  year_2018_proportions,
  headship_hours,
} from "./restrictions.js";
import { glosary, glosary_abreviations } from "./glosary";
import { year_wages, brp_bonus_wages } from "./wages";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import moment from "moment";
import DatePicker from "react-datepicker";
import FirebaseApi from "../../api/firebase";
import { connect } from "react-redux";
import toastr from "toastr";
import { Typeahead } from "react-bootstrap-typeahead";
import ProtectedPage from "../protected/ProtectedPage";

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    //this.state = props.contractInfo
  }

  componentWillMount = () => {
    this.state = this.props.contractInfo;
    this.state.teacher = {};
    this.state.teacher = this.props.teacherInfo;
    this.state.teacher_key = this.props.teacherInfo.id;
    this.retrieveProportions();
    this.retrieveHourValues();
    this.retrieveSchedule();
  };

  componentWillUnmount = () => {
    let contract = this.state;
    if (!this.state.saved) {
      this.props.setContractInfoState(contract);
    }
  };

  componentWillReceiveProps(nextProps) {
    this.state = nextProps.contractInfo;
    this.state.teacher = {};
    this.state.teacher = this.props.teacherInfo;
  }

  checkIfDateIsInRange = (range_start, range_end, date) => {
    let start = moment(range_start, "DD-MM-YYYY");
    let end = moment(range_end, "DD-MM-YYYY");
    let checking = moment(date, "DD-MM-YYYY");

    return checking.isBetween(start, end, null, []);
  };

  retrieveProportions = () => {
    FirebaseApi.GetValues("/proportions/")
      .then((snap) => {
        let proportionsObjs = snap.val();
        if (proportionsObjs) {
          let keys = Object.keys(proportionsObjs);
          let intersections_count = 0;
          keys.forEach((key) => {
            let current_proportions = proportionsObjs[key];
            let isInRange = this.checkIfDateIsInRange(
              current_proportions["start_date"],
              current_proportions["end_date"],
              this.state.signing_date
            );

            if (isInRange) {
              console.log("proportions");
              console.log(current_proportions);
              intersections_count += 1;
              this.restriction_proportions = {
                A: current_proportions["A"],
                B: current_proportions["B"],
              };
              isInRange = false;
            }
          });
          if (intersections_count == 0) {
            alert(
              "No existen proporciones definidas para la fecha de firma elegida"
            );
          } else if (intersections_count > 1) {
            alert(
              "Existen multiples proporciones para la fecha de firma elegida, reportar error"
            );
          }
          this.forceUpdate();
        } else {
          alert("No existen proporciones ");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  retrieveSchedule = () => {
    if (this.state.selectedOption != "") {
      FirebaseApi.GetValues("/schedules/" + this.state.selectedOption.value)
        .then((snap) => {
          let schedulesObjs = snap.val();
          if (schedulesObjs) {
            let keys = Object.keys(schedulesObjs);
            let intersections_count = 0;
            keys.forEach((key) => {
              let current_schedule = schedulesObjs[key];
              let isInRange = this.checkIfDateIsInRange(
                current_schedule["start_date"],
                current_schedule["end_date"],
                this.state.signing_date
              );

              if (isInRange) {
                intersections_count += 1;
                console.log("schedule");
                console.log(current_schedule);
                this.setState(
                  {
                    selected_schedule_type: current_schedule,
                  },
                  () => {
                    if (this.state.updateScheduleFormat) {
                      this.generateGrids();
                      this.setState({ updateScheduleFormat: false });
                    }
                  }
                );
                isInRange = false;
              }
            });
            if (intersections_count == 0) {
              alert(
                "No existe un horario definido para el colegio y la fecha de firma elegida"
              );
            } else if (intersections_count > 1) {
              alert(
                "Existen multiples horarios para la fecha de firma elegida, reportar error"
              );
            }
            this.forceUpdate();
          } else {
            alert("No existen horarios ");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  retrieveHourValues = () => {
    let year = moment(this.state.signing_date, "DD-MM-YYYY").year();
    FirebaseApi.GetValues("/hour_values/" + year)
      .then((snap) => {
        let hour_values_obj = snap.val();
        if (hour_values_obj) {
          this.hour_values = {
            A: hour_values_obj["A"],
            B: hour_values_obj["B"],
            C: hour_values_obj["C"],
          };
          this.forceUpdate();
          //console.log(this.hour_values)
        } else {
          alert("No existen valores hora para la fecha de firma elegida ");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  generateDetailedScheduleGrid = (schedule_type) => {
    let currentTimeString = schedule_type.begin_time;
    let currentTime = moment(currentTimeString, "HH:mm:ss");
    let cell_style = "schedule-cell ";
    let row_header_cell_style = "period-type-cell";
    let block_to_detailed_mapping = [];
    //let datetime = new Date('1970-01-01T' + timeString + 'Z');
    let new_grid = [
      [
        { readOnly: true, value: "", colSpan: 3 },
        { value: "Lunes", readOnly: true },
        { value: "Martes", readOnly: true },
        { value: "Miércoles", readOnly: true },
        { value: "Jueves", readOnly: true },
        { value: "Viernes", readOnly: true },
      ],
    ];

    let break_counter = 1;
    let class_counter = 1;
    for (let period of schedule_type.schedule_format) {
      if (period.type === "class") {
        let period_type =
          period.type === "class" ? "Clases - " + class_counter : "";
        class_counter += 1;
        let row_counter = 0;
        let period_mapping_object = { type: period_type };
        for (let interval = 0; interval < period.minutes; interval += 5) {
          let start = currentTime.format("HH:mm");
          let end = currentTime.add("m", 5).format("HH:mm");

          if (interval + 5 == period.minutes) {
            cell_style += " period-end-row-cell";
            row_header_cell_style = "period-type-end-row-cell";
          }
          new_grid.push([
            {
              value: period_type,
              readOnly: true,
              width: 10,
              className: row_header_cell_style,
            },
            { value: start, readOnly: true, className: cell_style },
            { value: end, readOnly: true, className: cell_style },
            { value: "", className: cell_style },
            { value: "", className: cell_style },
            { value: "", className: cell_style },
            { value: "", className: cell_style },
            { value: "", className: cell_style },
          ]);
          row_counter += 1;
          cell_style = "schedule-cell";
          row_header_cell_style = "period-type-cell";
        }
        period_mapping_object["rows"] = row_counter;
        block_to_detailed_mapping.push(period_mapping_object);
      } else {
        let period_type =
          period.type === "break" ? "Recreo - " + break_counter : "Almuerzo";
        let row_counter = 0;
        let period_mapping_object = { type: period_type };
        for (let interval = 0; interval < period.minutes; interval += 5) {
          let start = currentTime.format("HH:mm");
          let end = currentTime.add("m", 5).format("HH:mm");
          if (interval + 5 == period.minutes) {
            cell_style = "period-end-row-cell";
            row_header_cell_style = "period-type-end-row-cell";
          }
          new_grid.push([
            {
              value: period_type,
              readOnly: true,
              className: row_header_cell_style,
            },
            {
              value: start,
              readOnly: true,
              className: cell_style + " " + row_header_cell_style,
            },
            {
              value: end,
              readOnly: true,
              className: cell_style + " " + row_header_cell_style,
            },
            { value: "", className: cell_style },
            { value: "", className: cell_style },
            { value: "", className: cell_style },
            { value: "", className: cell_style },
            { value: "", className: cell_style },
          ]);
          row_counter += 1;
          cell_style = "schedule-cell";
          row_header_cell_style = "period-end-row-cell period-type-cell";
        }
        period_mapping_object["rows"] = row_counter;
        block_to_detailed_mapping.push(period_mapping_object);
        if (period.type === "break") {
          break_counter += 1;
        }
      }
    }
    this.setState({ block_to_detailed_mapping });
    return new_grid;
  };

  generateBlockScheduleGrid = (schedule_type) => {
    let currentTimeString = schedule_type.begin_time;
    let currentTime = moment(currentTimeString, "HH:mm:ss");
    let cell_style = "schedule-cell";
    let row_header_cell_style = "period-type-cell";
    let block_grid = [
      [
        { readOnly: true, value: "", colSpan: 3 },
        { value: "Lunes", readOnly: true },
        { value: "Martes", readOnly: true },
        { value: "Miércoles", readOnly: true },
        { value: "Jueves", readOnly: true },
        { value: "Viernes", readOnly: true },
      ],
    ];
    let break_counter = 1;
    let class_counter = 1;
    for (let period of schedule_type.schedule_format) {
      if (period.type === "class") {
        let period_type = "Clases - " + class_counter;
        class_counter += 1;
        let start = currentTime.format("HH:mm");
        let end = currentTime.add("m", period.minutes).format("HH:mm");
        /*let corresponding_detailed_row = []
          this.state.detailed_grid.forEach((row) => {
            let target_row =  this.state.detailed_grid[this.state.detailed_grid.findIndex(x => x.value === start.format('HH:mm'))]
            console.log(row)
          })*/

        //console.log(corresponding_detailed_row)
        block_grid.push([
          {
            value: period_type,
            readOnly: true,
            className: row_header_cell_style,
          },
          { value: start, readOnly: true },
          { value: end, readOnly: true },
          { value: "", className: cell_style },
          { value: "", className: cell_style },
          { value: "", className: cell_style },
          { value: "", className: cell_style },
          { value: "", className: cell_style },
        ]);
      } else {
        let start = currentTime.format("HH:mm");
        let end = currentTime.add("m", period.minutes).format("HH:mm");
        let period_type =
          period.type === "break" ? "Recreo - " + break_counter : "Almuerzo";
        break_counter =
          period.type === "break" ? break_counter + 1 : break_counter;
        block_grid.push([
          {
            value: period_type,
            readOnly: true,
            className: row_header_cell_style + " break",
          },
          {
            value: start,
            readOnly: true,
            className: row_header_cell_style + " break",
          },
          {
            value: end,
            readOnly: true,
            className: row_header_cell_style + " break",
          },
          { value: "", className: cell_style + " break" },
          { value: "", className: cell_style + " break" },
          { value: "", className: cell_style + " break" },
          { value: "", className: cell_style + " break" },
          { value: "", className: cell_style + " break" },
        ]);
      }
    }
    return block_grid;
  };

  generateFinalScheduleGrid = () => {
    console.log("generating");
    let final_grid = this.state.final_grid;
    let detailed_grid_row_cursor = 1;
    for (
      let period = 0;
      period < this.state.block_to_detailed_mapping.length;
      period += 1
    ) {
      let current_period_mapping = this.state.block_to_detailed_mapping[period];
      //Loop over each day
      let current_detailed_grid_row_cursor = detailed_grid_row_cursor;
      for (
        let day = 3;
        day < this.state.detailed_grid[detailed_grid_row_cursor].length;
        day += 1
      ) {
        let cell_content = { strings: [], objects: [] };
        current_detailed_grid_row_cursor = detailed_grid_row_cursor;
        for (
          let interval = 0;
          interval < current_period_mapping.rows;
          interval++
        ) {
          if (
            cell_content.strings.indexOf(
              this.state.detailed_grid[current_detailed_grid_row_cursor][day]
                .value
            ) == -1
          ) {
            cell_content.strings.push(
              this.state.detailed_grid[current_detailed_grid_row_cursor][day]
                .value
            );
            cell_content.objects.push({
              string:
                this.state.detailed_grid[current_detailed_grid_row_cursor][day]
                  .value,
              duration: 5,
            });
          } else {
            let index_of_string = cell_content.strings.indexOf(
              this.state.detailed_grid[current_detailed_grid_row_cursor][day]
                .value
            );
            cell_content.objects[index_of_string].duration += 5;
          }
          current_detailed_grid_row_cursor += 1;
        }
        //Generate compound cell content
        let cell_content_string = "";
        for (let i = 0; i < cell_content.objects.length; i++) {
          if (cell_content.strings[i] != "") {
            if (cell_content_string.length > 0) {
              cell_content_string += ",";
            }
            cell_content_string +=
              " " +
              this.abreviate(cell_content.strings[i]) +
              "(" +
              cell_content.objects[i].duration +
              ")";
          }
        }
        final_grid[period + 1][day].value = cell_content_string;
      }
      detailed_grid_row_cursor = current_detailed_grid_row_cursor;
    }
  };

  abreviate = (value) => {
    if (glosary.includes(value.toLowerCase().trim())) {
      let obj = glosary_abreviations.find(function (obj) {
        return obj.value === value.toLowerCase().trim();
      });
      return obj.abreviation;
    } else {
      return value;
    }
  };

  addHiddenSepToTotalMinutes = (selectedOption) => {
    let headship_minutes = 0;
    let non_visible_sep_1 = 0;
    //Sum SEP 1 minutes not reflected in schedule
    if (selectedOption.value == "parvularia") {
      headship_minutes += 120;
      non_visible_sep_1 = 120;
    } else if (selectedOption.value == "básica_1_a_4") {
      headship_minutes += 135;
      non_visible_sep_1 = 135;
    } else if (selectedOption.value == "básica_5_a_6") {
      headship_minutes += 0;
    } else if (selectedOption.value == "básica_7_a_8") {
      headship_minutes += 0;
    } else if (selectedOption.value == "media") {
      headship_minutes += 0;
    }
    return {
      headship_minutes: headship_minutes,
      non_visible_sep_1: non_visible_sep_1,
    };
  };

  computeTotalMinutes = (total_minutes, sep_1_minutes) => {
    return total_minutes + sep_1_minutes;
  };

  handleChange = (selectedOption) => {
    let selected_schedule =
      selectedOption.value === "san-jose"
        ? san_jose_schedule
        : san_joaquin_schedule;

    //retrieve new schedule

    /*
      let selected_schedule_type = ''
      switch(selectedOption.value) {
        case 'san-jose':
          selected_schedule_type = san_jose_type
          break;
        case 'san-joaquin':
          selected_schedule_type = san_joaquin_type
          break;
        case 'san-juan':
          selected_schedule_type = san_juan_type
        case 'san-jose-2':
          selected_schedule_type = san_jose_2_type        
          break;
      }*/

    this.setState(
      { selectedOption: selectedOption, updateScheduleFormat: true },
      () => {
        this.retrieveSchedule();
      }
    );
  };

  generateGrids = () => {
    let detailed_grid = this.generateDetailedScheduleGrid(
      this.state.selected_schedule_type
    );
    let block_grid = this.generateBlockScheduleGrid(
      this.state.selected_schedule_type
    );
    let final_grid = this.generateBlockScheduleGrid(
      this.state.selected_schedule_type
    );

    this.setState(
      {
        detailed_grid: detailed_grid,
        grid: block_grid,
        final_grid: final_grid,
      },
      this.updateMinutes(detailed_grid)
    );
  };

  handleHeadshipChange = (selectedOption) => {
    let res = this.addHiddenSepToTotalMinutes(selectedOption);
    let total_minutes_final = this.computeTotalMinutes(
      this.state.total_minutes,
      res.headship_minutes
    );
    this.setState({
      headship: selectedOption,
      total_minutes_final,
      sep_1_headship_minutes: res.headship_minutes,
      categories_minutes: {
        ...this.state.categories_minutes,
        non_visible_sep_1: res.non_visible_sep_1,
      },
    });
  };

  handleStartDateChange = (date) => {
    this.setState({
      startDate: date.value,
    });
  };

  handleStartPeriodChange = (period) => {
    this.setState({
      startPeriod: period.value,
    });
  };

  handleProportionsTypeChange = (proportions_type) => {
    this.setState({
      proportions_type: proportions_type.value,
    });
  };

  handleContractDateChange = (date) => {
    this.setState({
      contractDate: date.format("DD-MM-YYYY"),
    });
  };

  handleNameInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const id = target.id;

    this.setState({
      [id]: value,
    });
  };

  handleOldHoursInputChange = (event) => {
    const target = event.target;
    const value = parseFloat(target.value);
    const name = target.name;

    const { old_hours } = this.state;
    let new_old_hours = {
      ...old_hours,
      [name]: value,
    };

    this.setState({
      old_hours: new_old_hours,
    });
  };

  handleOverwritedHoursInputChange = (event) => {
    const target = event.target;
    const value = parseFloat(target.value);
    const name = target.name;
    const { overwrited_hours } = this.state;
    let new_overwrited_hours = {
      ...overwrited_hours,
      [name]: value,
    };

    this.setState({
      overwrited_hours: new_overwrited_hours,
    });
  };

  handleProportionChange = (event) => {
    this.setState({
      proportion_to_use: event.target.value,
    });
  };

  handleCheckboxChange = (event) => {
    let { bonuses } = this.state;
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    bonuses[name] = value;
    this.setState({
      bonuses,
    });
  };

  handleSep2TypeChange = (event) => {
    this.setState({
      sep_2_hour_type: event.target.value,
    });
  };

  handleSep2ValueChange = (event) => {
    this.setState({
      sep_2_hour_value_other: parseFloat(event.target.value),
    });
  };

  handleSep3ValueChange = (event) => {
    this.setState({
      sep_3_hour_value: parseFloat(event.target.value),
    });
  };

  handleYardTurnValueChange = (event) => {
    this.setState({
      yard_turn_hour_value: parseFloat(event.target.value),
    });
  };

  handleSigningDateChange = (date) => {
    this.setState(
      {
        signing_date: date.format("DD-MM-YYYY"),
        updateScheduleFormat: true,
      },
      () => {
        this.retrieveProportions();
        this.retrieveHourValues();
        this.retrieveSchedule();
      }
    );
  };

  handlePIEValuesChange = (event) => {
    this.setState({
      [event.target.name]: parseFloat(event.target.value),
    });
  };

  handleSignedChange = (event) => {
    this.setState({
      signed: event.target.value === "true" ? true : false,
    });
  };

  handleOverwritedChange = (event) => {
    const target = event.target;
    const name = target.name;
    const { overwrited } = this.state;
    let new_overwrited = {
      ...overwrited,
      [name]: event.target.checked,
    };
    this.setState({
      overwrited: new_overwrited,
    });
  };
  onTabSelect = (tabIndex) => {
    if (tabIndex == 2) {
      this.generateFinalScheduleGrid();
    }
    this.setState({ tabIndex });
  };
  onBlockGridChange = (cell, rowI, colJ, value) => {
    let start = moment(this.state.grid[rowI][1].value, "HH:mm:ss");
    let end = moment(this.state.grid[rowI][2].value, "HH:mm:ss");
    let new_detailed_grid = this.state.detailed_grid.slice();
    if (end != null) {
      new_detailed_grid.forEach((row) => {
        if (
          moment(row[1].value, "HH:mm:ss").isBetween(start, end) ||
          moment(row[1].value, "HH:mm:ss").isSame(start)
        ) {
          //Revisar funcionalidad de poner nombres estandares en detailed grid (mayusculas)
          row[colJ].value = value;
          if (!glosary.includes(value.toLowerCase().trim())) {
            if (!row[colJ].className.includes("error")) {
              row[colJ].className = row[colJ].className.replace(/empty/g, "");
              row[colJ].className += " error";
            }
          } else {
            if (value.toLowerCase().trim() == "") {
              row[colJ].className = row[colJ].className.replace(/error/g, "");
              row[colJ].className += " empty";
            } else {
              row[colJ].className = row[colJ].className.replace(/error/g, "");
              row[colJ].className = row[colJ].className.replace(/empty/g, "");
            }
          }
        }
      });
    } else {
      new_detailed_grid.forEach((row) => {
        if (this.state.grid[rowI][1].value === row[1].value) {
          /*console.log(this.state.grid[rowI][0])
            console.log(row[0])
            /*console.log(row)
            console.log(colJ)
            console.log(rowI)*/
          //row[colJ].value = value
        }
      });
    }

    this.setState(
      {
        grid: this.state.grid.map((col) =>
          col.map((rowCell) => {
            if (rowCell == cell) {
              if (!glosary.includes(value.toLowerCase().trim())) {
                if (!rowCell.className.includes("error")) {
                  rowCell.className += " error";
                  rowCell.className = rowCell.className.replace(/empty/g, "");
                }
              } else {
                if (value.toLowerCase().trim() == "") {
                  rowCell.className = rowCell.className.replace(/error/g, "");
                  rowCell.className += " empty";
                } else {
                  rowCell.className = rowCell.className.replace(/error/g, "");
                  rowCell.className = rowCell.className.replace(/empty/g, "");
                }
              }
              return { value: value, className: rowCell.className };
            } else {
              return rowCell;
            }
          })
        ),
        detailed_grid: new_detailed_grid,
      },
      this.updateMinutes(new_detailed_grid)
    );
  };

  onDetailedGridChange = (cell, rowI, colJ, value) => {
    let new_detailed_grid = this.state.detailed_grid.map((col) =>
      col.map((rowCell) => {
        if (rowCell == cell) {
          if (!glosary.includes(value.toLowerCase().trim())) {
            if (!rowCell.className.includes("error")) {
              rowCell.className += " error";
              rowCell.className = rowCell.className.replace(/empty/g, "");
            }
          } else {
            if (value.toLowerCase().trim() == "") {
              rowCell.className = rowCell.className.replace(/error/g, "");
              rowCell.className += " empty";
            } else {
              rowCell.className = rowCell.className.replace(/error/g, "");
              rowCell.className = rowCell.className.replace(/empty/g, "");
            }
          }
          return { value: value, className: rowCell.className };
        } else {
          return rowCell;
        }
      })
    );
    this.setState(
      {
        detailed_grid: new_detailed_grid,
      },
      this.updateMinutes(new_detailed_grid)
    );
  };

  onFinalGridChange = (cell, rowI, colJ, value) => {
    console.log("test");
  };
  updateMinutes = (detailed_grid) => {
    //Para flexibilizar cambiar este hours por un objeto global definido previamente (store?), lo mismo con glosary
    let categories_minutes = {
      middle_classroom: 0,
      high_classroom: 0,
      break: 0,
      non_academic: 0,
      sep_1: 0,
      sep_2: 0,
      sep_3: 0,
      colab: 0,
      pie_middle_classroom: 0,
      pie_high_classroom: 0,
      yard_turn: 0,
      non_visible_sep_1: this.state.categories_minutes.non_visible_sep_1,
      float: 0,
    };

    detailed_grid.forEach((row, rowIndex) => {
      row.forEach((cell, cellIndex) => {
        if (
          glosary.includes(cell.value.toLowerCase().trim()) &&
          cell.value != ""
        ) {
          let obj = glosary_abreviations.find(function (obj) {
            return obj.value === cell.value.toLowerCase().trim();
          });
          categories_minutes[obj.type] += 5;
        }
      });
    });
    let total_minutes = 0;
    for (let index = 3; index < detailed_grid[1].length; index++) {
      let day_start = moment(
        this.getStartOfDay(detailed_grid, index),
        "HH:mm:ss"
      );
      let day_end = moment(this.getEndOfDay(detailed_grid, index), "HH:mm:ss");
      let day_minutes = !isNaN(day_end.diff(day_start))
        ? day_end.diff(day_start) / 1000 / 60
        : 0;
      total_minutes += day_minutes;
    }
    let total_minutes_final = this.computeTotalMinutes(
      total_minutes,
      this.state.sep_1_headship_minutes
    );

    this.setState({
      categories_minutes: categories_minutes,
      total_minutes,
      total_minutes_final,
    });
  };

  getStartOfDay = (detailed_grid, day_index) => {
    let start_time = "";
    detailed_grid.forEach((row, rowIndex) => {
      //Dont read the first row (shorter)
      if (rowIndex != 0) {
        if (
          glosary.includes(row[day_index].value.toLowerCase().trim()) &&
          row[day_index].value.toLowerCase().trim() != ""
        ) {
          if (start_time == "") {
            start_time = row[1].value;
          }
        }
      }
    });
    return start_time;
  };

  getEndOfDay = (detailed_grid, day_index) => {
    let end_time = "";
    let reversed_grid = detailed_grid.slice(0).reverse();
    reversed_grid.forEach((row, rowIndex) => {
      //Dont read the first row (shorter, reversed)
      if (rowIndex < detailed_grid.length - 1) {
        if (
          glosary.includes(row[day_index].value.toLowerCase().trim()) &&
          row[day_index].value.toLowerCase().trim() != ""
        ) {
          if (end_time == "") {
            end_time = row[2].value;
          }
        }
      }
    });
    return end_time;
  };

  checkProportionRestriction = (type, minutes_of_type) => {
    //let base_hours = (this.state.categories_minutes.middle_classroom +  this.state.categories_minutes.high_classroom +
    //this.state.categories_minutes.break + this.state.categories_minutes.non_academic) / 60
    let academic_hours =
      (this.state.categories_minutes.middle_classroom +
        this.state.categories_minutes.high_classroom) /
      45;
    let rounded_hours = Math.round(academic_hours);
    rounded_hours = rounded_hours > 41 ? 41 : rounded_hours;
    //const limit = year_2018_proportions_new['' + rounded_hours][type]

    let limit;
    if (this.restriction_proportions != null) {
      limit =
        this.restriction_proportions[this.getProportionsType()][
          "" + rounded_hours
        ][type];
    } else {
      limit = 0;
    }
    let threshold = type == "classroom_teaching_hours" ? 0 : 5;
    return this.compareToLimit(limit, minutes_of_type, threshold);
  };

  checkModulesProportionRestriction = (type, modules_of_type) => {
    //let base_hours = (this.state.categories_minutes.middle_classroom +  this.state.categories_minutes.high_classroom +
    //this.state.categories_minutes.break + this.state.categories_minutes.non_academic) / 60
    let academic_hours =
      (this.state.categories_minutes.middle_classroom +
        this.state.categories_minutes.high_classroom) /
      45;
    let rounded_hours = Math.round(academic_hours);
    rounded_hours = rounded_hours > 41 ? 41 : rounded_hours;
    //const module_limit = this.myToFixed(year_2018_proportions_new['' + rounded_hours][type] / 45)
    let module_limit;
    if (this.restriction_proportions != null) {
      module_limit = this.myToFixed(
        this.restriction_proportions[this.getProportionsType()][
          "" + rounded_hours
        ][type] / 45
      );
    } else {
      module_limit = 0;
    }

    let threshold = 0.5;
    return this.compareToLimit(module_limit, modules_of_type, threshold);
  };

  checkMaxHoursRestriction = (max_hours, current_hours, threshold) => {
    return this.compareToLimit(max_hours, current_hours, threshold);
  };

  compareToLimit = (max_quantity, current_quantity, threshold) => {
    if (
      current_quantity >= max_quantity &&
      current_quantity - threshold <= max_quantity
    ) {
      //Sobran horas de este tipo
      let diff = this.myToFixed(current_quantity - max_quantity);
      let printable_diff = " (+" + diff + ")";
      return {
        satisfies: true,
        printable_diff: printable_diff,
      };
    } else if (
      current_quantity >= max_quantity &&
      current_quantity - threshold > max_quantity
    ) {
      let diff = this.myToFixed(current_quantity - max_quantity);
      let printable_diff = " (+" + diff + ")";
      return {
        satisfies: false,
        printable_diff: printable_diff,
      };
    } else {
      let diff = this.myToFixed(max_quantity - current_quantity);
      let printable_diff = " (-" + diff + ")";
      return {
        satisfies: false,
        printable_diff: printable_diff,
      };
    }
  };

  myToFixed = (val) => {
    return parseFloat(val.toFixed(2));
  };

  roundNearest5Tenth = (val) => {
    let decimal_part = (val * 100) % 100;

    if (decimal_part >= 50) {
      return Math.round(val * 2) / 2;
    } else {
      let doubled = val * 2;
      let modulo = (doubled * 100) % 100;

      let rounded =
        modulo > 50 ? Math.round(doubled) / 2 : Math.floor(doubled) / 2;

      return rounded;
    }
  };

  //Salary calculators

  calculateBaseSalary2 = () => {
    let middle_classroom_hour_price =
      year_wages[moment(this.state.teacher.start_date, "DD-MM-YYYY").year()]
        .middle;
    let high_classroom_hour_price =
      year_wages[moment(this.state.teacher.start_date, "DD-MM-YYYY").year()]
        .high;

    let middle_classroom_hours = this.myToFixed(
      this.computeMiddleClassroomMinutes() / 60
    );
    let high_classroom_hours = this.myToFixed(
      this.computeHighClassroomMinutes() / 60
    );
    let non_academic_hours = this.myToFixed(
      this.computeNonAcademicMinutes() / 60
    );
    let break_hours = this.myToFixed(this.computeBreakMinutes() / 60);

    let pie_middle_classroom_hours = this.myToFixed(
      this.state.categories_minutes.pie_middle_classroom / 60
    );
    let pie_high_classroom_hours = this.myToFixed(
      this.state.categories_minutes.pie_high_classroom / 60
    );

    //Weighted hour price (for break and non_academic)
    let weighted_hour_price = 0;
    if (this.state.proportion_to_use == "new") {
      let total_academic_hours = middle_classroom_hours + high_classroom_hours;
      let middle_classroom_proportion =
        total_academic_hours > 0
          ? middle_classroom_hours / total_academic_hours
          : 0.5;
      let high_classroom_proportion =
        total_academic_hours > 0
          ? high_classroom_hours / total_academic_hours
          : 0.5;
      weighted_hour_price =
        middle_classroom_proportion * middle_classroom_hour_price +
        high_classroom_proportion * high_classroom_hour_price;
    } else if (this.state.proportion_to_use == "old") {
      let total_old_hours =
        this.state.old_hours.middle_classroom +
        this.state.old_hours.high_classroom;
      let middle_classroom_old_proportion =
        this.state.old_hours.middle_classroom / total_old_hours;
      let high_classroom_old_proportion =
        this.state.old_hours.high_classroom / total_old_hours;
      weighted_hour_price =
        middle_classroom_old_proportion * middle_classroom_hour_price +
        high_classroom_old_proportion * high_classroom_hour_price;
    }

    //Academic salary
    let academic_hours_salary =
      middle_classroom_hours * middle_classroom_hour_price +
      high_classroom_hours * high_classroom_hour_price;

    //Break Salary
    let break_hours_salary = break_hours * weighted_hour_price;

    //Non academic
    let non_academic_hours_salary = non_academic_hours * weighted_hour_price;

    //PIE Salary
    let pie_salary =
      pie_middle_classroom_hours * this.state.pie_middle_classroom_hour_value +
      pie_high_classroom_hours * this.state.pie_high_classroom_hour_value;

    return Math.round(
      academic_hours_salary +
        break_hours_salary +
        non_academic_hours_salary +
        pie_salary
    );
  };

  //Real base salary calculator
  calculateBaseSalary = () => {
    let hour_values_array_index = this.state.startDate - 1992;

    let base_salary = 0;
    let middle_classroom_hours = 0;
    let high_classroom_hours = 0;

    if (this.hour_values != null) {
      let period_letter = String.fromCharCode(65 + this.state.startPeriod);
      let middle_classroom_hour_price =
        this.hour_values[period_letter][hour_values_array_index].middle;
      let high_classroom_hour_price =
        this.hour_values[period_letter][hour_values_array_index].high;
      let minutes = this.getDistributedClassroomMinutesForSalary();

      //Get hours from minutes, approximate to nearest 0.5
      middle_classroom_hours = this.roundNearest5Tenth(minutes.middle / 60);
      high_classroom_hours = this.roundNearest5Tenth(minutes.high / 60);

      base_salary =
        middle_classroom_hours * middle_classroom_hour_price +
        high_classroom_hours * high_classroom_hour_price;
    }

    return {
      salary: base_salary,
      middle_hours: middle_classroom_hours,
      high_hours: high_classroom_hours,
    };
  };

  calculateSEP1Salary = () => {
    console.log(this.hour_values);
    console.log(this.state.headship);
    let headship = this.state.headship.value;
    let sep_1_hour_price = 0;

    if (this.hour_values != null) {
      let period_letter = String.fromCharCode(65 + this.state.startPeriod);
      let hour_values_array_index = this.state.startDate - 1992;
      console.log(hour_values_array_index);

      if (
        headship == "parvularia" ||
        headship == "básica_1_a_4" ||
        headship == "básica_5_a_6" ||
        headship == "básica_7_a_8"
      ) {
        sep_1_hour_price =
          this.hour_values[period_letter][hour_values_array_index].middle;
      } else if (headship == "media") {
        sep_1_hour_price =
          this.hour_values[period_letter][hour_values_array_index].high;
      }
    }

    //let sep_1_hours = Math.floor(this.state.categories_minutes.sep_1 / 60)
    let sep_1_hours = 0;
    if (this.state.overwrited.sep_1) {
      sep_1_hours = this.state.overwrited_hours.sep_1;
    } else {
      sep_1_hours = headship_hours[headship].payable;
    }
    return {
      salary: Math.floor(sep_1_hours * sep_1_hour_price),
      hours: sep_1_hours,
    };
  };

  calculateSEP2Salary = () => {
    let middle_classroom_hour_price = 0;
    let high_classroom_hour_price = 0;

    if (this.hour_values != null) {
      let period_letter = String.fromCharCode(65 + this.state.startPeriod);
      let hour_values_array_index = this.state.startDate - 1992;

      middle_classroom_hour_price =
        this.hour_values[period_letter][hour_values_array_index].middle;
      high_classroom_hour_price =
        this.hour_values[period_letter][hour_values_array_index].high;
    }

    //let middle_classroom_minutes = this.computeMiddleClassroomMinutes()
    //let high_classroom_minutes = this.computeHighClassroomMinutes()

    let res = this.getDistributedClassroomMinutesForSalary();
    let middle_classroom_minutes = res.middle;
    let high_classroom_minutes = res.high;

    let hour_price = 0;
    if (this.state.sep_2_hour_type == "middle") {
      hour_price = middle_classroom_hour_price;
    } else if (this.state.sep_2_hour_type == "high") {
      hour_price = high_classroom_hour_price;
    } else if (this.state.sep_2_hour_type == "weighted") {
      let middle_classroom_hours = this.roundNearest5Tenth(
        middle_classroom_minutes / 60
      );
      let high_classroom_hours = this.roundNearest5Tenth(
        high_classroom_minutes / 60
      );
      //Weighted hour price (for break and non_academic)
      if (this.state.proportion_to_use == "new") {
        //By minutes

        //let total_academic_minutes= middle_classroom_minutes + high_classroom_minutes
        //let middle_classroom_proportion = total_academic_minutes > 0 ?  middle_classroom_minutes / total_academic_minutes : 0.5
        //let high_classroom_proportion =  total_academic_minutes > 0 ?  high_classroom_minutes / total_academic_minutes : 0.5

        //By hours

        let total_academic_hours =
          middle_classroom_hours + high_classroom_hours;
        let middle_classroom_proportion =
          total_academic_hours > 0
            ? middle_classroom_hours / total_academic_hours
            : 0.5;
        let high_classroom_proportion =
          total_academic_hours > 0
            ? high_classroom_hours / total_academic_hours
            : 0.5;
        hour_price = Math.round(
          middle_classroom_proportion * middle_classroom_hour_price +
            high_classroom_proportion * high_classroom_hour_price
        );
      } else if (this.state.proportion_to_use == "old") {
        let total_old_hours =
          this.state.old_hours.middle_classroom +
          this.state.old_hours.high_classroom;
        let middle_classroom_old_proportion =
          this.state.old_hours.middle_classroom / total_old_hours;
        let high_classroom_old_proportion =
          this.state.old_hours.high_classroom / total_old_hours;
        hour_price =
          middle_classroom_old_proportion * middle_classroom_hour_price +
          high_classroom_old_proportion * high_classroom_hour_price;
      }
    } else if (this.state.sep_2_hour_type == "other") {
      hour_price = this.state.sep_2_hour_value_other;
    }

    let sep_2_hours = this.roundNearest5Tenth(this.computeSEP2Minutes() / 60);

    return { salary: Math.floor(sep_2_hours * hour_price), hours: sep_2_hours };
  };

  calculateSEP3Salary = () => {
    let sep_3_hours = this.roundNearest5Tenth(this.computeSEP3Minutes() / 60);

    let { sep_3_hour_value } = this.state;

    return { salary: sep_3_hour_value * sep_3_hours, hours: sep_3_hours };
  };

  calculateTotalHours = () => {
    let headship = this.state.headship.value;
    let base_salary_object = this.calculateBaseSalary();
    let base_hours =
      base_salary_object.middle_hours + base_salary_object.high_hours;
    let sep_1_hours = 0;
    if (this.state.overwrited.sep_1) {
      sep_1_hours = this.state.overwrited_hours.sep_1;
    } else {
      sep_1_hours = headship_hours[headship].payable;
    }
    let sep_2_hours = this.roundNearest5Tenth(this.computeSEP2Minutes() / 60);
    let sep_3_hours = this.roundNearest5Tenth(this.computeSEP3Minutes() / 60);

    return base_hours + sep_1_hours + sep_2_hours + sep_3_hours;
  };
  calculateLawBonusSalary = (type) => {
    let ley_salary = 0;
    let total_hours = 0;
    if (
      this.state.selected_schedule_type != undefined &&
      this.state.selected_schedule_type != ""
    ) {
      //let total_hours = Object.values(this.state.categories_minutes).reduce((a, b) => a + b) / 60
      //total_hours =this.roundNearest5Tenth(this.computeTotalMinutesFinal() / 60)
      //console.log('Total minutes final: ' + this.computeTotalMinutesFinal())
      //console.log('Calculating hours: ' + total_hours)
      total_hours = this.calculateTotalHours();
      total_hours = total_hours > 44 ? 44 : total_hours;
      if (type == "normal") {
        if (this.state.bonuses.ley) {
          //let bonus_hour_price = this.getScheduleTypeData(this.state.selectedOption.value).bonus_hour_price
          let bonus_hour_price =
            this.state.selected_schedule_type.bonus_hour_price;
          ley_salary = total_hours * bonus_hour_price;
        }
      } else if (type == "pie") {
        if (this.state.bonuses.ley_pie) {
          //let bonus_hour_price = this.getScheduleTypeData(this.state.selectedOption.value).bonus_hour_price_PIE
          let bonus_hour_price =
            this.state.selected_schedule_type.bonus_hour_price_PIE;
          ley_salary = total_hours * bonus_hour_price;
        }
      }
    }

    return { salary: Math.round(ley_salary), hours: total_hours };
  };

  calculateBRPBonusSalary = (type) => {
    let brp_salary = 0;
    //Round to nearest integer
    let total_hours = Math.round(this.calculateTotalHours());
    total_hours = total_hours > 44 ? 44 : total_hours;
    total_hours = isNaN(total_hours) ? 0 : total_hours;
    let hour_price = 0;
    if (
      this.state.selected_schedule_type.bonus_values != undefined &&
      this.state.selected_schedule_type.bonus_values != ""
    ) {
      if (type == "titulo" && this.state.bonuses.brp_titulo) {
        //brp_salary = brp_bonus_wages[total_hours].titulo
        brp_salary =
          this.state.selected_schedule_type.bonus_values[total_hours]["titulo"];
      } else if (type == "mencion" && this.state.bonuses.brp_mencion) {
        //brp_salary = brp_bonus_wages[total_hours].mencion
        brp_salary =
          this.state.selected_schedule_type.bonus_values[total_hours][
            "mencion"
          ];
      }
    } else {
      if (type == "titulo" && this.state.bonuses.brp_titulo) {
        brp_salary = brp_bonus_wages[total_hours].titulo;
      } else if (type == "mencion" && this.state.bonuses.brp_mencion) {
        brp_salary = brp_bonus_wages[total_hours].mencion;
      }
    }

    return { salary: brp_salary, hours: total_hours };
  };

  calculateMovilizationSalary = () => {
    let movilization_salary = 0;
    let working_days = 0;
    //Calculate working days
    if (!(this.state.detailed_grid[1] == null)) {
      for (let index = 3; index < this.state.detailed_grid[1].length; index++) {
        let day_start = this.getStartOfDay(this.state.detailed_grid, index);
        let day_end = this.getEndOfDay(this.state.detailed_grid, index);
        if (day_start != "") {
          working_days += 1;
        }
      }
    }
    if (
      !(this.state.selected_schedule_type == null) &&
      this.state.selected_schedule_type != ""
    ) {
      //let schedule_type = this.getScheduleTypeData(this.state.selectedOption.value)
      let schedule_type = this.state.selected_schedule_type;
      let segment = this.calculateMovilizationSegment();

      if (schedule_type.movilization_bonus != null) {
        let mov_bonus_for_year = schedule_type.movilization_bonus;
        if (mov_bonus_for_year != null) {
          let mov_bonus_for_year_period = mov_bonus_for_year;

          if (mov_bonus_for_year_period != null) {
            let mov_bonus_for_year_period_working_days =
              mov_bonus_for_year_period[working_days];

            if (mov_bonus_for_year_period_working_days != null) {
              movilization_salary = mov_bonus_for_year_period_working_days;
            } else {
              //alert("No hay valores de movilización para la cantidad de dias en que el docente trabaja: " + working_days + " días" )
            }
          } else {
            alert(
              "No hay valores de movilziación para el mes de fecha de firma elegido"
            );
          }
        } else {
          alert(
            "No hay valores de movilización para el año de fecha de firma elegido"
          );
        }
      } else {
        //alert("No hay información de pagos por movilizaciones")
      }
    }
    return Math.round(movilization_salary);
  };

  calculateMovilizationSegment = () => {
    let res = {
      year: 0,
      period: 0,
    };
    let month = moment(this.state.signing_date, "DD-MM-YYYY").month();
    let year = moment(this.state.signing_date, "DD-MM-YYYY").year();
    if (month >= 2 && month <= 7) {
      res.year = year;
      res.period = 0;
    } else if (month > 7) {
      res.year = year;
      res.period = 1;
    } else {
      res.year = year - 1;
      res.period = 1;
    }
    return res;
  };

  //Now it gets the values from wages.js. In the future it should get values from DB
  getScheduleTypeData = (schedule_type) => {
    switch (schedule_type) {
      case "san-jose":
        return san_jose_type;
      case "san-joaquin":
        return san_joaquin_type;
      case "san-juan":
        return san_juan_type;
      case "san-jose-2":
        return san_jose_2_type;
      default:
        return null;
    }
  };

  getProportionsType = () => {
    let ret =
      this.state.proportions_type == null ? "A" : this.state.proportions_type;
    return ret;
  };
  saveContract = () => {
    let salary = {
      taxable: {
        base: this.calculateBaseSalary(),
        sep_1: this.calculateSEP1Salary(),
        sep_2: this.calculateSEP2Salary(),
        sep_3: this.calculateSEP3Salary(),
        brp_titulo: this.calculateBRPBonusSalary("titulo"),
        brp_mencion: this.calculateBRPBonusSalary("mencion"),
        ley: this.calculateLawBonusSalary("normal"),
        ley_pie: this.calculateLawBonusSalary("pie"),
      },
      non_taxable: {
        movilization: this.calculateMovilizationSalary(),
      },
    };
    this.state.saved = true;
    let succes_message = "";
    //Saving new contract
    if (this.state.id == "") {
      let { teacher, ...contract } = this.state;
      delete contract["teacher_list"];
      let last_modify = FirebaseApi.serverTimestamp();

      FirebaseApi.databasePush("/contracts", {
        ...contract,
        teacher_key: contract.teacher_key,
        salary: salary,
        name: teacher.name,
        duplicate: false,
        teacher: teacher,
        last_modification: last_modify,
      }).then((val) => {
        //now that we have the key in val, create a entry in /teachers (new method)
        //let path = '/teachers/' + this.state.rut + "/" + this.state.selectedOption.label + '/' + val
        let path =
          "/teachers/" +
          contract.teacher_key +
          "/" +
          contract.selectedOption.label +
          "/" +
          val;

        //before inserting new teacher, clean rut and format it according to db format (no dots), cleaned
        //let sanitized_rut = this.sanitizeRut(this.state.rut)
        FirebaseApi.databaseUpdate(
          "/teachers/" +
            contract.teacher_key +
            "/contracts/" +
            contract.selectedOption.label,
          { [val]: true }
        );
        console.log("created entry in teacher");

        //process contract and insert new contract into /contract_summary
        let date = contract.signing_date.split("-");
        let processedContract = {
          name: teacher.name,
          school: contract.selectedOption.label,
          signing_date: date[2] + "-" + date[1] + "-" + date[0],
          id: val,
          last_modification: last_modify,
          signed: contract.signed,
          startDate: contract.startDate,
          teacher_key: contract.teacher_key,
        };
        console.log(processedContract);
        FirebaseApi.databaseSet("/contracts_summary/" + val, processedContract);

        succes_message = "Anexo creado";
        this.props.resetContractInfo();
        this.props.history.push("/contracts");
        toastr.success(succes_message);
      });
    }
    //Editing contract
    else {
      FirebaseApi.databaseSet("/contracts/" + this.state.id, {
        ...this.state,
        salary: salary,
        last_modification: FirebaseApi.serverTimestamp(),
      });
      succes_message = "Anexo actualizado";

      toastr.success(succes_message);

      //process contract and edit contract into /contract_summary
      let date = this.state.signing_date.split("-");
      let processedContract = {
        name: this.state.teacher.name,
        school: this.state.selectedOption.label,
        signing_date: date[2] + "-" + date[1] + "-" + date[0],
        id: this.state.id,
        last_modification: this.state.last_modification,
        signed: this.state.signed,
        startDate: this.state.startDate,
        teacher_key: this.state.teacher_key,
      };
      console.log(processedContract);

      FirebaseApi.databaseSet(
        "/contracts_summary/" + this.state.id,
        processedContract
      );

      //Update teacher's contract values in case they changed (like type of schedule which is a key)
      //Modify state.teachers.contracts
      //1. find the key (which schedule type) is the parent of this contract id which might have changed ntype and name
      //Check if name changed by comapring parent key to this contract.selectedoption label
      //2. change the key in DB if schedule type changed

      let teacher = this.state.teacher;
      let contract_id = this.state.id;
      let label = this.state.selectedOption.label;
      let del = false;

      Object.keys(teacher.contracts).forEach((key) => {
        if (!del) {
          if (contract_id in teacher.contracts[key]) {
            delete teacher.contracts[key][contract_id];

            //Managge if parent of deleted field is now empty
            if (Object.keys(teacher.contracts[key]) == 0) {
              delete teacher.contracts[key];
            }
            if (label in teacher.contracts) {
              teacher.contracts[label][contract_id] = true;
            } else {
              teacher.contracts[label] = {};
              teacher.contracts[label][contract_id] = true;
            }

            del = true;
          } else {
          }
        }
      });

      FirebaseApi.databaseSet("/teachers/" + teacher.id, teacher);
      this.props.resetContractInfo();
      this.props.history.push("/contracts");
    }
  };

  sanitizeRut = (rut) => {
    let clean_rut = rut.split(".").join("");
    let number_rut = clean_rut.split("-")[0];
    let verification_digit = clean_rut.split("-")[1];
    let sanitized_rut_number = parseInt(number_rut).toString();
    let sanitized_rut = sanitized_rut_number + "-" + verification_digit;
    return sanitized_rut;
  };

  clearContract = () => {
    this.props.resetContractInfo();
  };

  duplicateContract = () => {
    let empty_teacher = {
      id: "",
      name: "",
      rut: "",
      sign_date: "",
      contracts: {},
    };
    let contract = {
      ...this.state,
      id: "",
      teacher: empty_teacher,
      teacher_key: "",
      duplicate: true,
      loading_teachers: true,
    };
    this.setState(contract);
    let teachers = [];
    FirebaseApi.GetValues("/teachers").then((snap) => {
      let teachersObj = snap.val();
      if (teachersObj) {
        Object.keys(teachersObj).forEach((key) => {
          teachers.push({ ...teachersObj[key], key: key });
        });
      }
      this.setState({ teacher_list: teachers, loading_teachers: false });
    });

    //this.props.setContractInfoState(contract)
  };

  generateNextContract = () => {
    let current_contract = this.state;
    let new_contract = {
      name: current_contract.teacher.name,
      rut: current_contract.rut,
      startDate: current_contract.startDate,
      startPeriod: current_contract.startPeriod,
      contractDate: current_contract.teacher.start_date,
      selectedOption: current_contract.selectedOption,
    };

    //metodo que busca el ultimo contrato de este profesor en este colegio
    let last_contract = this.searchLastContract(
      current_contract.teacher_key,
      new_contract.selectedOption.label
    );
    last_contract.then((res) => {
      let contract_data = res[Object.keys(res)[0]];
      new_contract["old_hours"] = {
        high_classroom: contract_data.salary.taxable.base.high_hours,
        middle_classroom: contract_data.salary.taxable.base.middle_hours,
        sep_1: contract_data.salary.taxable.sep_1.hours,
        sep_2: contract_data.salary.taxable.sep_2.hours,
        sep_3: contract_data.salary.taxable.sep_3.hours,
      };
      new_contract["teacher"] = contract_data.teacher;

      //this.setState()
      new_contract["detailed_grid"] = this.generateDetailedScheduleGrid(
        current_contract.selected_schedule_type
      );
      new_contract["grid"] = this.generateBlockScheduleGrid(
        current_contract.selected_schedule_type
      );
      new_contract["final_grid"] = this.generateBlockScheduleGrid(
        current_contract.selected_schedule_type
      );
      new_contract["selected_schedule_type"] =
        current_contract.selected_schedule_type;

      new_contract["block_to_detailed_mapping"] =
        current_contract.block_to_detailed_mapping;

      new_contract["generating_next"] = true;

      this.props.resetContractInfo();

      this.props.setContractInfoState(new_contract);
      //remains to check that a contract made this way is saved successfully and also load automatically next info from config
    });
  };

  searchLastContract = (teacher_key, school) => {
    return FirebaseApi.GetValueByKeyOnce("teachers", teacher_key).then(
      (snap) => {
        let res = snap.val();
        let res_keys = Object.keys(res);
        let teacher = null;
        res_keys.length > 0 ? (teacher = res[res_keys[0]]) : null;
        let school_teacher = teacher["contracts"][school];
        if (typeof school_teacher != "undefined") {
          let contract_ids = Object.keys(school_teacher);
          console.log(contract_ids);
          //get contracts
          let contracts = [];

          let contractPromises = contract_ids.map((contract_id) => {
            return FirebaseApi.GetValueByKeyOnce("contracts", contract_id);
          });
          return Promise.all(contractPromises)
            .then((contracts) => {
              contracts.forEach((contract, i) => {
                console.log("Contract id: " + i);
                console.log(contract);
                console.log(contract.val());
                contracts[i] = contract.val();
              });
              console.log("cont");
              console.log(contracts);
              let sorted_contracts = this.sortContracts(contracts.slice());
              console.log(sorted_contracts);
              let ret = null;
              sorted_contracts.length > 0
                ? (ret = sorted_contracts[0])
                : (ret = null);
              return ret;
            })
            .catch((err) => {
              console.log("Couldn't fetch last contract, erro:");
              console.log(err);
            });
        } else {
          return null;
        }
      }
    );
  };

  sortContracts = (contracts) => {
    function compare(a, b) {
      if (
        moment(a[Object.keys(a)[0]]["signing_date"], "DD-MM-YYYY").isBefore(
          moment(b[Object.keys(b)[0]]["signing_date"], "DD-MM-YYYY")
        )
      )
        return 1;
      else return -1;
      return 0;
    }

    return contracts.sort(compare);
  };

  getDistributedClassroomMinutes = (purpouse) => {
    let middle_classroom_minutes = 0;
    let high_classroom_minutes = 0;
    let non_academic_minutes = 0;
    let break_minutes = 0;
    let colaboration_minutes = 0;
    if (purpouse == "salary") {
      middle_classroom_minutes = this.computeMiddleClassroomMinutes();
      high_classroom_minutes = this.computeHighClassroomMinutes();
      non_academic_minutes = this.computeNonAcademicMinutes();
      break_minutes = this.computeBreakMinutes();
      colaboration_minutes = this.computeColaborationMinutes();
    } else if (purpouse == "restriction" || purpouse == "counter") {
      middle_classroom_minutes = this.state.categories_minutes.middle_classroom;
      high_classroom_minutes = this.state.categories_minutes.high_classroom;
      non_academic_minutes = this.state.categories_minutes.non_academic;
      break_minutes = this.state.categories_minutes.break;
      colaboration_minutes = this.state.categories_minutes.colab;
    }

    let pie_middle_classroom_minutes =
      this.state.categories_minutes.pie_middle_classroom;
    let pie_high_classroom_minutes =
      this.state.categories_minutes.pie_high_classroom;

    //On progress
    let yard_turn_minutes = this.state.categories_minutes.yard_turn;

    //Weighted proportion
    let middle_classroom_proportion = 0;
    let high_classroom_proportion = 0;
    if (this.state.proportion_to_use == "new") {
      let total_academic_minutes =
        middle_classroom_minutes + high_classroom_minutes;
      middle_classroom_proportion =
        total_academic_minutes > 0
          ? middle_classroom_minutes / total_academic_minutes
          : 0.5;
      high_classroom_proportion =
        total_academic_minutes > 0
          ? high_classroom_minutes / total_academic_minutes
          : 0.5;
    } else if (this.state.proportion_to_use == "old") {
      let total_old_hours =
        this.state.old_hours.middle_classroom +
        this.state.old_hours.high_classroom;
      middle_classroom_proportion =
        this.state.old_hours.middle_classroom / total_old_hours;
      high_classroom_proportion =
        this.state.old_hours.high_classroom / total_old_hours;
    }

    //Distribute and sum non academic minutes
    middle_classroom_minutes +=
      middle_classroom_proportion * non_academic_minutes;
    high_classroom_minutes += high_classroom_proportion * non_academic_minutes;

    //Distribute and sum break minutes
    middle_classroom_minutes += middle_classroom_proportion * break_minutes;
    high_classroom_minutes += high_classroom_proportion * break_minutes;

    //Sum Colaboration minutes
    middle_classroom_minutes +=
      middle_classroom_proportion * colaboration_minutes;
    high_classroom_minutes += high_classroom_proportion * colaboration_minutes;

    //Sum PIE minutes
    middle_classroom_minutes += pie_middle_classroom_minutes;
    high_classroom_minutes += pie_high_classroom_minutes;

    //Sum yard turn minutes
    middle_classroom_minutes += middle_classroom_proportion * yard_turn_minutes;
    high_classroom_minutes += high_classroom_proportion * yard_turn_minutes;

    if (this.state.overwrited.middle && purpouse == "salary") {
      middle_classroom_minutes = this.state.overwrited_hours.middle * 60;
    }

    if (this.state.overwrited.high && purpouse == "salary") {
      high_classroom_minutes = this.state.overwrited_hours.high * 60;
    }

    return { middle: middle_classroom_minutes, high: high_classroom_minutes };
  };

  getDistributedClassroomMinutesForSalary = () => {
    let distributedMinutes = this.getDistributedClassroomMinutes("counter");
    if (this.state.overwrited.middle) {
      distributedMinutes.middle = this.state.overwrited_hours.middle * 60;
    }

    if (this.state.overwrited.high) {
      distributedMinutes.high = this.state.overwrited_hours.high * 60;
    }

    return distributedMinutes;
  };
  generatePeriodOptions = () => {
    let periods = [];
    let numberOfPeriods = 3;
    Array.from(new Array(numberOfPeriods), (x, i) => i).map((period) => {
      periods.push({ value: period, label: String.fromCharCode(65 + period) });
    });
    return periods;
  };

  computeMiddleClassroomMinutes = () => {
    let minutes = this.state.overwrited.middle
      ? this.state.overwrited_hours.middle * 60
      : this.state.categories_minutes.middle_classroom;
    return isNaN(minutes) ? 0 : minutes;
  };

  computeHighClassroomMinutes = () => {
    let minutes = this.state.overwrited.high
      ? this.state.overwrited_hours.high * 60
      : this.state.categories_minutes.high_classroom;
    return isNaN(minutes) ? 0 : minutes;
  };

  computeBreakMinutes = () => {
    let minutes = this.state.categories_minutes.break;
    return isNaN(minutes) ? 0 : minutes;
  };

  computeNonAcademicMinutes = () => {
    let minutes = this.state.categories_minutes.non_academic;
    return isNaN(minutes) ? 0 : minutes;
  };

  computeColaborationMinutes = () => {
    let minutes = this.state.categories_minutes.colab;
    return isNaN(minutes) ? 0 : minutes;
  };

  computeSEP1Minutes = () => {
    let minutes = this.state.overwrited.sep_1
      ? this.state.overwrited_hours.sep_1 * 60
      : this.state.categories_minutes.sep_1;
    return isNaN(minutes) ? 0 : minutes;
  };

  computeSEP2Minutes = () => {
    let minutes = this.state.overwrited.sep_2
      ? this.state.overwrited_hours.sep_2 * 60
      : this.state.categories_minutes.sep_2;
    return isNaN(minutes) ? 0 : minutes;
  };

  computeSEP3Minutes = () => {
    let minutes = this.state.overwrited.sep_3
      ? this.state.overwrited_hours.sep_3 * 60
      : this.state.categories_minutes.sep_3;
    return isNaN(minutes) ? 0 : minutes;
  };

  computeTotalMinutesFinal = () => {
    let total_minutes = this.state.total_minutes_final;
    let distributedMinutes = this.getDistributedClassroomMinutes("counter");
    //Dont consider schedule and hidden sep_1 minutes, they are fixed
    total_minutes -= this.state.categories_minutes.non_visible_sep_1;
    total_minutes -= this.state.categories_minutes.sep_1;
    //Add fixed sep_1 minutes
    total_minutes += headship_hours[this.state.headship.value].payable * 60;

    //Substract float minutes because they are not defined yet
    //total_minutes-= this.state.categories_minutes.float
    this.state.categories_minutes.float == null
      ? ""
      : (total_minutes -= this.state.categories_minutes.float);

    if (this.state.overwrited.middle) {
      //Substract counted middle minutes and add overwrited
      total_minutes -= distributedMinutes.middle;
      total_minutes += this.state.overwrited_hours.middle * 60;
    }

    if (this.state.overwrited.high) {
      //Substract counted high minutes and add overwrited
      total_minutes -= distributedMinutes.high;
      total_minutes += this.state.overwrited_hours.high * 60;
    }

    if (this.state.overwrited.sep_1) {
      //Substract counted sep 1 minutes and add overwrited
      total_minutes -= headship_hours[this.state.headship.value].payable * 60;
      total_minutes += this.state.overwrited_hours.sep_1 * 60;
    }

    if (this.state.overwrited.sep_2) {
      //Substract counted sep 2 minutes and add overwrited
      total_minutes -= this.state.categories_minutes.sep_2;
      total_minutes += this.state.overwrited_hours.sep_2 * 60;
    }

    // Not implemented yet
    /*
      if(this.state.overwrited.sep_3) {
        //Substract counted sep 2 minutes and add overwrited
        total_minutes -= this.state.categories_minutes.sep_3
        total_minutes += this.state.overwrited_hours.sep_3 * 60
      }*/
    return total_minutes;
  };

  checkOldHoursInvalidNumberInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (value == "") {
      let { old_hours } = this.state;
      old_hours = { ...old_hours, [name]: 0 };
      this.setState({ old_hours });
    }
  };

  checkOverwritedHoursInvalidNumberInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (value == "") {
      let { overwrited_hours } = this.state;
      overwrited_hours = { ...overwrited_hours, [name]: 0 };
      this.setState({ overwrited_hours });
    }
  };

  teacherSelectionChanged = (selected) => {
    if (selected.length > 0) {
      let new_teacher = {
        id: selected[0].key,
        rut: selected[0].rut,
        name: selected[0].name,
        sign_date: "",
        start_date: selected[0].start_date,
        contracts: selected[0].contracts != null ? selected[0].contracts : {},
      };
      this.setState({
        teacher: new_teacher,
        teacher_key: selected[0].key,
        name: selected[0].name,
      });
    }
  };

  setComments = (manual_1, manual_2, comment) => {
    this.setState({ manual_1, manual_2, comment });
  };

  setExtraHours = (segment_assignation, complementary_payroll) => {
    this.setState({ segment_assignation, complementary_payroll });
  };

  setNewSepValues = (sep_1_value, sep_2_value) => {
    this.setState({ sep_1_value, sep_2_value });
  };

  hourCounterSection = (key, minutes) => {
    return (
      <tr key={key}>
        <td>{key}</td>
        <td>{this.myToFixed(minutes / 60)}</td>
        <td>{this.myToFixed(minutes / 45)}</td>
      </tr>
    );
  };

  generateStartDateOptions = () => {
    //Get the last possible year for hour value
    let last_year = moment(this.state.signing_date, "DD-MM-YYYY").year();
    let number_of_years = last_year - 1992 + 1;
    let year_options = Array.from(
      new Array(number_of_years),
      (x, i) => 1992 + i
    ).map((year) => {
      return { value: year, label: year };
    });
    return year_options;
  };

  processContract = (contractInfo, key) => {
    let date = contractInfo.signing_date.split("-");
    let processedContract = {
      name: contractInfo.name,
      school: contractInfo.selectedOption.label,
      signing_date: date[2] + "-" + date[1] + "-" + date[0],
      //signing_date: contractInfo.signing_date,
      id: key,
      last_modification: contractInfo.last_modification,
      signed: contractInfo.signed,
      startDate: contractInfo.startDate,
      teacher_key: contractInfo.teacher_key,
    };
    return processedContract;
  };
  render() {
    let categories = {
      middle_classroom: "Aula Básica",
      high_classroom: "Aula Media",
      float: "Flotancia",
      sep_1: "SEP 1",
      non_visible_sep_1: "SEP 1 No en horario",
      sep_2: "SEP 2",
      sep_3: "SEP 3",
      pie_middle_classroom: "PIE Básica",
      pie_high_classroom: "PIE Media",
      non_academic: "Horas no lectivas",
      colab: "Complementaria",
      break: "Recreo Docente",
      yard_turn: "Turno de Patio",
      total: "Totales",
    };

    let classroom_teaching_minutes =
      this.computeMiddleClassroomMinutes() + this.computeHighClassroomMinutes();
    let base_hours =
      classroom_teaching_minutes +
      this.computeBreakMinutes() +
      this.computeNonAcademicMinutes();

    //let classroom_teaching_proportion_restriction_check = this.checkProportionRestriction('classroom_teaching', classroom_teaching_minutes)
    let break_proportion_restriction_check = this.checkProportionRestriction(
      "break",
      this.state.categories_minutes.break
    );
    let break_modules_proportion_restriction_check =
      this.checkModulesProportionRestriction(
        "break",
        this.myToFixed(this.state.categories_minutes.break / 45)
      );

    let non_academic_proportion_restriction_check =
      this.checkProportionRestriction(
        "non_academic",
        this.state.categories_minutes.non_academic
      );
    let non_academic_modules_proportion_restriction_check =
      this.checkModulesProportionRestriction(
        "non_academic",
        this.myToFixed(this.state.categories_minutes.non_academic / 45)
      );
    //let classroom_teaching_hours_proportion_restriction_check = this.checkProportionRestriction('classroom_teaching_hours', classroom_teaching_minutes / 45)

    let proportion_restriction_check = {
      //classroom_teaching_hours: {
      //minutes: classroom_teaching_minutes / 45,
      //check_result: classroom_teaching_hours_proportion_restriction_check,
      //span_class: classroom_teaching_hours_proportion_restriction_check.satisfies ? 'correct' :  'incorrect'
      // },
      //classroom_teaching: {
      //minutes: this.myToFixed(classroom_teaching_minutes),
      //check_result: classroom_teaching_proportion_restriction_check,
      //span_class: classroom_teaching_proportion_restriction_check.satisfies ? 'correct' :  'incorrect'
      //},
      break: {
        minutes: this.myToFixed(this.state.categories_minutes.break),
        check_result: break_proportion_restriction_check,
        span_class: break_proportion_restriction_check.satisfies
          ? "correct"
          : "incorrect",
      },
      break_modules: {
        modules: this.myToFixed(this.state.categories_minutes.break / 45),
        check_result: break_modules_proportion_restriction_check,
        span_class: break_modules_proportion_restriction_check.satisfies
          ? "correct"
          : "incorrect",
      },
      non_academic: {
        minutes: this.myToFixed(this.state.categories_minutes.non_academic),
        check_result: non_academic_proportion_restriction_check,
        span_class: non_academic_proportion_restriction_check.satisfies
          ? "correct"
          : "incorrect",
      },
      non_academic_modules: {
        modules: this.myToFixed(
          this.state.categories_minutes.non_academic / 45
        ),
        check_result: non_academic_modules_proportion_restriction_check,
        span_class: non_academic_modules_proportion_restriction_check.satisfies
          ? "correct"
          : "incorrect",
      },
    };

    let max_hours_restriction_check = this.checkMaxHoursRestriction(
      45,
      this.state.total_minutes_final / 60,
      0
    );
    let current_headship_minimum_hours =
      headship_hours[this.state.headship.value].visible;
    let current_headship_minutes = this.computeSEP1Minutes();
    let headship_hours_restriction_check = this.checkMaxHoursRestriction(
      current_headship_minimum_hours,
      current_headship_minutes / 60,
      0.2
    );

    let total_old_hours =
      this.state.old_hours.middle_classroom +
      this.state.old_hours.high_classroom;
    let middle_classroom_old_hours_proportion =
      total_old_hours > 0
        ? this.state.old_hours.middle_classroom / total_old_hours
        : 0;
    let high_classroom_old_hours_proportion =
      total_old_hours > 0
        ? this.state.old_hours.high_classroom / total_old_hours
        : 0;

    let total_current_hours = classroom_teaching_minutes / 60;
    let middle_classroom_current_hours_proportion = isNaN(
      this.computeMiddleClassroomMinutes() / 60 / total_current_hours
    )
      ? 0
      : this.computeMiddleClassroomMinutes() / 60 / total_current_hours;
    let high_classroom_current_hours_proportion = isNaN(
      this.computeHighClassroomMinutes() / 60 / total_current_hours
    )
      ? 0
      : this.computeHighClassroomMinutes() / 60 / total_current_hours;

    let middle_classroom_old_hours_restriction = this.checkMaxHoursRestriction(
      middle_classroom_old_hours_proportion,
      middle_classroom_current_hours_proportion,
      0
    );
    let high_classroom_old_hours_restriction = this.checkMaxHoursRestriction(
      high_classroom_old_hours_proportion,
      high_classroom_current_hours_proportion,
      0
    );

    let distributedClassroomMinutes =
      this.getDistributedClassroomMinutes("restriction");
    let middle_classroom_old_hours_quantity_restriction =
      this.checkMaxHoursRestriction(
        this.state.old_hours.middle_classroom,
        distributedClassroomMinutes.middle / 60,
        0
      );
    let high_classroom_old_hours_quantity_restriction =
      this.checkMaxHoursRestriction(
        this.state.old_hours.high_classroom,
        distributedClassroomMinutes.high / 60,
        0
      );
    let sep_1_old_hours_quantity_restriction = this.checkMaxHoursRestriction(
      this.state.old_hours.sep_1,
      this.computeSEP1Minutes() / 60,
      0
    );
    let sep_2_old_hours_quantity_restriction = this.checkMaxHoursRestriction(
      this.state.old_hours.sep_2,
      this.computeSEP2Minutes() / 60,
      0
    );
    let sep_3_old_hours_quantity_restriction = this.checkMaxHoursRestriction(
      this.state.old_hours.sep_3,
      this.computeSEP3Minutes() / 60,
      0
    );
    let total_old_hours_quantity_restriction = this.checkMaxHoursRestriction(
      this.state.old_hours.middle_classroom +
        this.state.old_hours.high_classroom,
      distributedClassroomMinutes.middle / 60 +
        distributedClassroomMinutes.high / 60,
      0
    );

    let salary = {
      taxable: {
        base: this.calculateBaseSalary(),
        sep_1: this.calculateSEP1Salary(),
        sep_2: this.calculateSEP2Salary(),
        sep_3: this.calculateSEP3Salary(),
        brp_titulo: this.calculateBRPBonusSalary("titulo"),
        brp_mencion: this.calculateBRPBonusSalary("mencion"),
        ley: this.calculateLawBonusSalary("normal"),
        ley_pie: this.calculateLawBonusSalary("pie"),
      },
      non_taxable: {
        movilization: this.calculateMovilizationSalary(),
      },
    };

    return (
      <div className="jumbotron">
        <div
          className="new-contract-button-container"
          style={
            (this.state.id == "" &&
              !this.state.duplicate &&
              !this.state.generating_next) ||
            true
              ? { display: "none" }
              : { display: "block" }
          }
        >
          <button
            className="btn btn-primary"
            onClick={() => this.clearContract()}
          >
            Crear Nuevo Anexo
          </button>
        </div>
        <h1>
          {this.state.id == ""
            ? this.state.duplicate
              ? "Duplicando Contrato Horario"
              : this.state.generating_next
              ? "Generando Anexo Siguiente Periodo"
              : "Nuevo Contrato Horario"
            : "Edición Contrato Horario"}
        </h1>
        <h2 className="orange">
          {this.state.id == "" ? "" : this.state.teacher.name}
        </h2>
        <div className="save-contract-button-container">
          <div className="save-contract-button">
            <button
              className="btn btn-success"
              onClick={() => this.saveContract()}
            >
              Guardar Anexo
            </button>
          </div>
          <div
            className="save-contract-button"
            style={
              this.state.id == "" ? { display: "none" } : { display: "block" }
            }
          >
            <button
              className="btn btn-warning"
              onClick={() => this.duplicateContract()}
            >
              Duplicar Anexo
            </button>
          </div>
          <div
            className="save-contract-button"
            style={
              this.state.id == "" || this.state.teacher_key == ""
                ? { display: "none" }
                : { display: "block" }
            }
          >
            <button
              className="btn btn-info"
              onClick={() => this.generateNextContract()}
            >
              Generar Siguiente Anexo
            </button>
          </div>
        </div>
        <Tabs>
          <TabList>
            <Tab>Información</Tab>
            <Tab>Horario</Tab>
            <Tab>PDF</Tab>
          </TabList>
          <TabPanel>
            <h3>Información</h3>
            <div className="information-container">
              <div className="form-group w-50">
                <label htmlFor="schedule-type">Tipo de horario</label>
                <Select
                  id="schedule-type"
                  name="schedule_type"
                  value={this.state.selectedOption.value}
                  onChange={this.handleChange}
                  options={[
                    { value: "san-jose", label: "San José" },
                    { value: "san-joaquin", label: "San Joaquín" },
                    {
                      value: "san-joaquin-preescolar",
                      label: "San Joaquín Preescolar",
                    },
                    { value: "san-juan", label: "San Juan" },
                    { value: "san-juan-basica", label: "San Juan Básica" },
                    {
                      value: "san-juan-preescolar",
                      label: "San Juan Preescolar",
                    },
                    { value: "san-juan-media", label: "San Juan Media" },
                    {
                      value: "san-jose-preescolar",
                      label: "San José Preescolar",
                    },
                    { value: "san-jose-basica", label: "San José Básica" },
                    { value: "san-jose-media", label: "San José Media" },
                    {
                      value: "santa-julia-basica",
                      label: "Santa Julia Básica",
                    },
                    { value: "santa-julia-media", label: "Santa Julia Media" },
                    {
                      value: "santa-julia-preescolar",
                      label: "Santa Julia Preescolar",
                    },
                  ]}
                  placeholder="Seleccionar tipo de Horario"
                />
              </div>

              <div
                className="form-group w-75"
                style={
                  !this.state.duplicate
                    ? { display: "none" }
                    : { display: "block" }
                }
              >
                <label htmlFor="teacher">Elegir Profesor</label>
                <Typeahead
                  onChange={this.teacherSelectionChanged}
                  options={this.state.teacher_list}
                  labelKey="name"
                />
              </div>
              <div className="form-group w-50">
                <label htmlFor="name">Nombre</label>
                <input
                  type="text"
                  id="name"
                  className="form-control "
                  value={this.state.teacher.name}
                  disabled={true}
                  onChange={this.handleNameInputChange}
                ></input>
              </div>
              <div className="form-group w-50">
                <label htmlFor="rut">Rut</label>
                <input
                  type="text"
                  id="rut"
                  className="form-control "
                  value={this.state.teacher.rut}
                  disabled={true}
                  onChange={this.handleNameInputChange}
                ></input>
              </div>
              <div className="form-group">
                <label>Fecha de firma</label>
                <DatePicker
                  selected={moment(this.state.signing_date, "DD-MM-YYYY")}
                  onChange={this.handleSigningDateChange}
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  scrollableYearDropdown
                  minDate={moment("1-1-1992", "DD-MM-YYYY")}
                  yearDropdownItemNumber={2}
                  dateFormat="DD/MM/YYYY"
                />
              </div>
              <div className="form-group w-25">
                <label htmlFor="startDate">Valor Hora</label>
                <div className="flex">
                  <div className="full-width">
                    <Select
                      name="startDate"
                      id="startDate"
                      value={this.state.startDate}
                      onChange={this.handleStartDateChange}
                      options={this.generateStartDateOptions()}
                      clearable={false}
                      placeholder="Valor Hora"
                    />
                  </div>
                  <div className="full-width">
                    <Select
                      name="startPeriod"
                      id="startPeriod"
                      value={this.state.startPeriod}
                      onChange={this.handleStartPeriodChange}
                      options={this.generatePeriodOptions()}
                      clearable={false}
                      placeholder="Periodo"
                    />
                  </div>
                </div>
              </div>
              <div className="form-group w-25">
                <label htmlFor="proportionsType">Tipo de proporciones</label>
                <div className="full-width">
                  <Select
                    name="proportionsType"
                    id="proportionsType"
                    value={this.state.proportions_type}
                    onChange={this.handleProportionsTypeChange}
                    options={[
                      { value: "A", label: "A" },
                      { value: "B", label: "B" },
                    ]}
                    clearable={false}
                  />
                </div>
              </div>
              <div className="form-group w-25">
                <label htmlFor="startDate">Fecha de Contrato</label>

                <DatePicker
                  selected={moment(this.state.teacher.start_date, "DD-MM-YYYY")}
                  onChange={this.handleContractDateChange}
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  scrollableYearDropdown
                  minDate={moment("1-1-1992", "DD-MM-YYYY")}
                  maxDate={moment()}
                  yearDropdownItemNumber={30}
                  dateFormat="DD/MM/YYYY"
                  disabled={true}
                />
              </div>
              <div className="form-group w-25">
                <label htmlFor="headship">Jefatura</label>
                <Select
                  name="headship"
                  id="headship"
                  value={this.state.headship.value}
                  onChange={this.handleHeadshipChange}
                  options={[
                    { value: "parvularia", label: "Parvularia" },
                    { value: "básica_1_a_4", label: "1° a 4° Básico" },
                    { value: "básica_5_a_6", label: "5° a 6° Básico" },
                    { value: "básica_7_a_8", label: "7° a 8° Básico" },
                    { value: "media", label: "Media" },
                    { value: "none", label: "Ninguna" },
                  ]}
                  placeholder="Tipo de jefatura"
                />
              </div>
              <div className="form-group w-25">
                <label htmlFor="middle-classroom-past-hours">
                  Horas Cronológicas Básica Año Anterior
                </label>
                <input
                  value={this.state.old_hours.middle_classroom}
                  type="number"
                  id="middle-classroom-past-hours"
                  className="form-control"
                  name="middle_classroom"
                  onBlur={this.checkOldHoursInvalidNumberInput}
                  onChange={this.handleOldHoursInputChange}
                ></input>
              </div>
              <div className="form-group w-25">
                <label htmlFor="high-classroom-past-hours">
                  Horas Cronológicas Media Año Anterior
                </label>
                <input
                  value={this.state.old_hours.high_classroom}
                  type="number"
                  id="high-classroom-past-hours"
                  className="form-control"
                  name="high_classroom"
                  onBlur={this.checkOldHoursInvalidNumberInput}
                  onChange={this.handleOldHoursInputChange}
                ></input>
              </div>
              <div className="form-group w-25">
                <label htmlFor="sep=1-past-hours">
                  Horas Cronológicas SEP 1 Año Anterior
                </label>
                <input
                  value={this.state.old_hours.sep_1}
                  type="number"
                  id="sep-1-past-hours"
                  className="form-control"
                  name="sep_1"
                  onBlur={this.checkOldHoursInvalidNumberInput}
                  onChange={this.handleOldHoursInputChange}
                ></input>
              </div>
              <div className="form-group w-25">
                <label htmlFor="sep-2-past-hours">
                  Horas Cronológicas SEP 2 Año Anterior
                </label>
                <input
                  value={this.state.old_hours.sep_2}
                  type="number"
                  id="sep-2-past-hours"
                  className="form-control"
                  name="sep_2"
                  onBlur={this.checkOldHoursInvalidNumberInput}
                  onChange={this.handleOldHoursInputChange}
                ></input>
              </div>
              <div className="form-group w-25">
                <label htmlFor="sep-3-past-hours">
                  Horas Cronológicas SEP 3 Año Anterior
                </label>
                <input
                  value={this.state.old_hours.sep_3}
                  type="number"
                  id="sep-3-past-hours"
                  className="form-control"
                  name="sep_3"
                  onBlur={this.checkOldHoursInvalidNumberInput}
                  onChange={this.handleOldHoursInputChange}
                ></input>
              </div>
              <div className="form-group w-25">
                <label>
                  <strong>Valor Hora Sep 2</strong>
                </label>
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      value="middle"
                      checked={this.state.sep_2_hour_type === "middle"}
                      onChange={this.handleSep2TypeChange}
                    />
                    Básica
                  </label>
                </div>
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      value="high"
                      checked={this.state.sep_2_hour_type === "high"}
                      onChange={this.handleSep2TypeChange}
                    />
                    Media
                  </label>
                </div>
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      value="weighted"
                      checked={this.state.sep_2_hour_type === "weighted"}
                      onChange={this.handleSep2TypeChange}
                    />
                    Proporción
                  </label>
                </div>
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      value="other"
                      checked={this.state.sep_2_hour_type === "other"}
                      onChange={this.handleSep2TypeChange}
                    />
                    Otro:
                  </label>
                  <div className="h-25">
                    <input
                      style={
                        this.state.sep_2_hour_type != "other"
                          ? { display: "none" }
                          : { display: "block" }
                      }
                      disabled={this.state.sep_2_hour_type != "other"}
                      type="number"
                      id="sep_2_hour_value_other"
                      className="form-control"
                      value={this.state.sep_2_hour_value_other}
                      onChange={this.handleSep2ValueChange}
                    ></input>
                  </div>
                </div>
              </div>
              <div className="form-group w-25">
                <label htmlFor="sep-3-value">Valor Hora SEP 3</label>
                <input
                  value={this.state.sep_3_hour_value}
                  type="number"
                  id="sep-3-value"
                  className="form-control"
                  name="sep_3_hour_value"
                  onChange={this.handleSep3ValueChange}
                ></input>
              </div>
              <div className="form-group w-25">
                <label htmlFor="yard-turn-value">
                  Valor Hora Turno de Patio
                </label>
                <input
                  value={this.state.yard_turn_hour_value}
                  type="number"
                  id="yard-turn-value"
                  className="form-control"
                  name="yard_turn_hour_value"
                  onChange={this.handleYardTurnValueChange}
                ></input>
              </div>
              <div className="form-group w-25">
                <div>
                  <label>
                    <strong>Bonos Activos</strong>
                  </label>
                </div>
                <div className="form-check">
                  <label className="form-check-label">
                    <input
                      name="brp_titulo"
                      type="checkbox"
                      checked={this.state.bonuses.brp_titulo}
                      onChange={this.handleCheckboxChange}
                      className="form-check-input"
                    />
                    Bono BRP Título
                  </label>
                </div>
                <div className="form-check">
                  <label className="form-check-label">
                    <input
                      name="brp_mencion"
                      type="checkbox"
                      checked={this.state.bonuses.brp_mencion}
                      onChange={this.handleCheckboxChange}
                      className="form-check-input"
                    />
                    Bono BRP Mención
                  </label>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <Tabs
              selectedIndex={this.state.tabIndex}
              onSelect={this.onTabSelect}
            >
              <TabList>
                <Tab>Bloques</Tab>
                <Tab>Detalle</Tab>
                <Tab>Vista final</Tab>
              </TabList>

              <TabPanel>
                <div className="scheduler-container">
                  <ReactDataSheet
                    className="schedule"
                    overflow="clip"
                    data={this.state.grid}
                    valueRenderer={(cell) => cell.value}
                    onChange={this.onBlockGridChange}
                  />
                </div>
              </TabPanel>
              <TabPanel>
                <div className="scheduler-container">
                  <ReactDataSheet
                    className="schedule"
                    overflow="clip"
                    data={this.state.detailed_grid}
                    valueRenderer={(cell) => cell.value}
                    onChange={this.onDetailedGridChange}
                  />
                </div>
              </TabPanel>
              <TabPanel>
                <div className="scheduler-container">
                  <ReactDataSheet
                    className="schedule"
                    overflow="clip"
                    data={this.state.final_grid}
                    valueRenderer={(cell) => cell.value}
                    onChange={this.onFinalGridChange}
                  />
                </div>
              </TabPanel>
            </Tabs>
            <div className="results-container">
              <div className="counter-restrictions-container">
                <div className="hours-counter">
                  <h2>Contador de horas</h2>
                  <table className="table table-striped table-hover centered-text table-sm">
                    <thead className="thead-light">
                      <tr>
                        <th>Categoría</th>
                        <th>Horas Cronológicas</th>
                        <th>Horas Pedagógicas</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.hourCounterSection(
                        categories["middle_classroom"],
                        this.state.categories_minutes["middle_classroom"]
                      )}
                      {this.hourCounterSection(
                        categories["high_classroom"],
                        this.state.categories_minutes["high_classroom"]
                      )}
                      {this.hourCounterSection(
                        categories["pie_middle_classroom"],
                        this.state.categories_minutes["pie_middle_classroom"]
                      )}
                      {this.hourCounterSection(
                        categories["pie_high_classroom"],
                        this.state.categories_minutes["pie_high_classroom"]
                      )}
                      {this.hourCounterSection(
                        categories["float"],
                        this.state.categories_minutes["float"]
                      )}
                      {this.hourCounterSection(
                        categories["sep_1"],
                        this.state.categories_minutes["sep_1"]
                      )}
                      {this.hourCounterSection(
                        categories["non_visible_sep_1"],
                        this.state.categories_minutes["non_visible_sep_1"]
                      )}
                      {this.hourCounterSection(
                        categories["sep_2"],
                        this.state.categories_minutes["sep_2"]
                      )}
                      {this.hourCounterSection(
                        categories["sep_3"],
                        this.state.categories_minutes["sep_3"]
                      )}
                      {this.hourCounterSection(
                        categories["non_academic"],
                        this.state.categories_minutes["non_academic"]
                      )}
                      {this.hourCounterSection(
                        categories["colab"],
                        this.state.categories_minutes["colab"]
                      )}
                      {this.hourCounterSection(
                        categories["break"],
                        this.state.categories_minutes["break"]
                      )}
                      {this.hourCounterSection(
                        categories["yard_turn"],
                        this.state.categories_minutes["yard_turn"]
                      )}
                      <tr className="sum-row" key="sum">
                        <td>Total Horas Sueldo</td>
                        {/*<td>{this.myToFixed(Object.values(this.state.categories_minutes).reduce((a, b) => a + b) / 60) }</td>
                            <td>{this.myToFixed(Object.values(this.state.categories_minutes).reduce((a, b) => a + b) / 45) }</td>*/}
                        <td>{this.myToFixed(this.calculateTotalHours())}</td>
                        <td>
                          {this.myToFixed(
                            (this.calculateTotalHours() * 60) / 45
                          )}
                        </td>
                      </tr>
                      <tr key="total">
                        <td>Total Horas Horario</td>
                        <td>
                          {this.myToFixed(this.state.total_minutes_final / 60)}
                        </td>
                        <td>
                          {this.myToFixed(this.state.total_minutes_final / 45)}
                        </td>
                      </tr>
                      <tr className="sum-row" key="diff">
                        <td>Diferencia</td>
                        {/*<td>{this.myToFixed(Object.values(this.state.categories_minutes).reduce((a, b) => a + b) / 60  - this.state.total_minutes_final / 60) }</td>
                            <td>{this.myToFixed(Object.values(this.state.categories_minutes).reduce((a, b) => a + b) / 45 - this.state.total_minutes_final / 45) }</td>*/}
                        <td>
                          {this.myToFixed(
                            this.calculateTotalHours() -
                              this.state.total_minutes_final / 60
                          )}
                        </td>
                        <td>
                          {this.myToFixed(
                            (this.calculateTotalHours() * 60) / 45 -
                              this.state.total_minutes_final / 45
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="restrictions">
                  <h2>Restricciones</h2>
                  <div className="restriction">
                    <h4>Restricción Mineduc</h4>
                    <table className="table table-striped table-hover centered-text table-sm">
                      <thead className="thead-light">
                        <tr>
                          <th>
                            Min Lec<strong>*</strong>
                          </th>
                          <th>
                            Min Rec<strong>*</strong>
                          </th>
                          <th>Modulos Rec</th>
                          <th>
                            Min NoLec<strong>*</strong>
                          </th>
                          <th>Modulos Nolec</th>
                          <th>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key="ministerio">
                          <td>{this.myToFixed(classroom_teaching_minutes)}</td>
                          <td>
                            {proportion_restriction_check.break.minutes}{" "}
                            <span
                              className={
                                proportion_restriction_check.break.span_class
                              }
                            >
                              {
                                proportion_restriction_check.break.check_result
                                  .printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {proportion_restriction_check.break_modules.modules}
                            <span
                              className={
                                proportion_restriction_check.break_modules
                                  .span_class
                              }
                            >
                              {
                                proportion_restriction_check.break_modules
                                  .check_result.printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {proportion_restriction_check.non_academic.minutes}{" "}
                            <span
                              className={
                                proportion_restriction_check.non_academic
                                  .span_class
                              }
                            >
                              {
                                proportion_restriction_check.non_academic
                                  .check_result.printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {
                              proportion_restriction_check.non_academic_modules
                                .modules
                            }
                            <span
                              className={
                                proportion_restriction_check
                                  .non_academic_modules.span_class
                              }
                            >
                              {
                                proportion_restriction_check
                                  .non_academic_modules.check_result
                                  .printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {proportion_restriction_check.break.check_result
                              .satisfies &&
                            proportion_restriction_check.non_academic
                              .check_result.satisfies ? (
                              <i
                                className="fa fa-check correct"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times incorrect"
                                aria-hidden="true"
                              ></i>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="alert alert-warning h-25">
                      <strong>
                        Estado Aprobado: Todos los * entre 0 y +5 minutos.
                      </strong>
                    </div>
                  </div>
                  <div className="restriction">
                    <h4>Jefatura</h4>
                    <table className="table table-striped table-hover centered-text table-sm">
                      <thead className="thead-light">
                        <tr>
                          <th>Mínimo de Horas</th>
                          <th>Horas Jefaturas Totales*</th>
                          <th>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key="headship_hours">
                          <td>{current_headship_minimum_hours}</td>
                          <td>
                            {this.myToFixed(current_headship_minutes / 60)}{" "}
                            <span
                              className={
                                headship_hours_restriction_check.satisfies
                                  ? "correct"
                                  : "incorrect"
                              }
                            >
                              {headship_hours_restriction_check.printable_diff}
                            </span>
                          </td>
                          <td>
                            {headship_hours_restriction_check.satisfies ? (
                              <i
                                className="fa fa-check correct"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times incorrect"
                                aria-hidden="true"
                              ></i>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="alert alert-warning h-25">
                      <strong>
                        Estado Aprobado: El campo con * entre 0 y +0.2.
                      </strong>
                    </div>
                  </div>
                  <div className="restriction">
                    <h4>Porcentaje por Categoría</h4>
                    <table className="table table-striped table-hover centered-text table-sm">
                      <thead className="thead-light">
                        <tr>
                          <th>Categoría</th>
                          <th></th>
                          <th>Porcentaje</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Aula Básica</td>
                          <td></td>
                          <td>
                            {this.myToFixed(
                              (this.state.categories_minutes.middle_classroom /
                                this.computeTotalMinutesFinal()) *
                                100
                            )}
                            %
                          </td>
                        </tr>
                        <tr>
                          <td>Aula Media</td>
                          <td></td>
                          <td>
                            {this.myToFixed(
                              (this.state.categories_minutes.high_classroom /
                                this.computeTotalMinutesFinal()) *
                                100
                            )}
                            %
                          </td>
                        </tr>
                        <tr>
                          <td>Colaboración</td>
                          <td></td>
                          <td>
                            {this.myToFixed(
                              (this.state.categories_minutes.colab /
                                this.computeTotalMinutesFinal()) *
                                100
                            )}
                            %
                          </td>
                        </tr>
                        <tr>
                          <td>Recreo Docente</td>
                          <td></td>
                          <td>
                            {this.myToFixed(
                              (this.state.categories_minutes.break /
                                this.computeTotalMinutesFinal()) *
                                100
                            )}
                            %
                          </td>
                        </tr>
                        <tr>
                          <td>No Lectiva</td>
                          <td></td>
                          <td>
                            {this.myToFixed(
                              (this.state.categories_minutes.non_academic /
                                this.computeTotalMinutesFinal()) *
                                100
                            )}
                            %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="restriction">
                    <h4>Proporción Horas Aula Básica y Media </h4>
                    <table className="table table-striped table-hover centered-text">
                      <thead className="thead-light">
                        <tr>
                          <th>Proporción Anterior</th>
                          <th>Proporción Actual</th>
                          <th>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key="max_hours">
                          <td>
                            {middle_classroom_old_hours_proportion.toFixed(2) +
                              " AB - " +
                              high_classroom_old_hours_proportion.toFixed(2) +
                              " AM"}
                          </td>
                          <td>
                            {middle_classroom_current_hours_proportion.toFixed(
                              2
                            ) + " AB "}{" "}
                            <span
                              className={
                                middle_classroom_old_hours_restriction.satisfies
                                  ? "correct"
                                  : "incorrect"
                              }
                            >
                              {" "}
                              {
                                middle_classroom_old_hours_restriction.printable_diff
                              }
                            </span>
                            <span> - </span>
                            {high_classroom_current_hours_proportion.toFixed(
                              2
                            ) + " AM "}{" "}
                            <span
                              className={
                                high_classroom_old_hours_restriction.satisfies
                                  ? "correct"
                                  : "incorrect"
                              }
                            >
                              {" "}
                              {
                                high_classroom_old_hours_restriction.printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {high_classroom_old_hours_restriction.satisfies &&
                            middle_classroom_old_hours_restriction.satisfies ? (
                              <i
                                className="fa fa-check correct"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times incorrect"
                                aria-hidden="true"
                              ></i>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="alert alert-warning h-25">
                      <strong>
                        Elija qué proporción usar clickeando las opciones en la
                        tabla de arriba.
                      </strong>
                    </div>
                  </div>
                  <div className="restriction">
                    <h4>Cantidad Horas Anteriores </h4>
                    <table className="table table-striped table-hover centered-text">
                      <thead className="thead-light">
                        <tr>
                          <th>Categoría</th>
                          <th>Cantidad Anterior</th>
                          <th>Cantidad Actual</th>
                          <th>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key="max_hours_middle">
                          <td>Básica</td>
                          <td>{this.state.old_hours.middle_classroom}</td>
                          <td>
                            {this.myToFixed(
                              distributedClassroomMinutes.middle / 60
                            )}{" "}
                            <span
                              className={
                                middle_classroom_old_hours_quantity_restriction.satisfies
                                  ? "correct"
                                  : "incorrect"
                              }
                            >
                              {" "}
                              {
                                middle_classroom_old_hours_quantity_restriction.printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {middle_classroom_old_hours_quantity_restriction.satisfies ? (
                              <i
                                className="fa fa-check correct"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times incorrect"
                                aria-hidden="true"
                              ></i>
                            )}
                          </td>
                        </tr>
                        <tr key="max_hours_high">
                          <td>Media</td>
                          <td>{this.state.old_hours.high_classroom}</td>
                          <td>
                            {this.myToFixed(
                              distributedClassroomMinutes.high / 60
                            )}{" "}
                            <span
                              className={
                                high_classroom_old_hours_quantity_restriction.satisfies
                                  ? "correct"
                                  : "incorrect"
                              }
                            >
                              {" "}
                              {
                                high_classroom_old_hours_quantity_restriction.printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {high_classroom_old_hours_quantity_restriction.satisfies ? (
                              <i
                                className="fa fa-check correct"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times incorrect"
                                aria-hidden="true"
                              ></i>
                            )}
                          </td>
                        </tr>
                        <tr key="max_hours_sep-1">
                          <td>SEP 1</td>
                          <td>{this.state.old_hours.sep_1}</td>
                          <td>
                            {this.myToFixed(this.computeSEP1Minutes() / 60)}{" "}
                            <span
                              className={
                                sep_1_old_hours_quantity_restriction.satisfies
                                  ? "correct"
                                  : "incorrect"
                              }
                            >
                              {" "}
                              {
                                sep_1_old_hours_quantity_restriction.printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {sep_1_old_hours_quantity_restriction.satisfies ? (
                              <i
                                className="fa fa-check correct"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times incorrect"
                                aria-hidden="true"
                              ></i>
                            )}
                          </td>
                        </tr>
                        <tr key="max_hours_sep-2">
                          <td>SEP 2</td>
                          <td>{this.state.old_hours.sep_2}</td>
                          <td>
                            {this.myToFixed(this.computeSEP2Minutes() / 60)}{" "}
                            <span
                              className={
                                sep_2_old_hours_quantity_restriction.satisfies
                                  ? "correct"
                                  : "incorrect"
                              }
                            >
                              {" "}
                              {
                                sep_2_old_hours_quantity_restriction.printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {sep_2_old_hours_quantity_restriction.satisfies ? (
                              <i
                                className="fa fa-check correct"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times incorrect"
                                aria-hidden="true"
                              ></i>
                            )}
                          </td>
                        </tr>
                        <tr key="max_hours_sep-3">
                          <td>SEP 3</td>
                          <td>{this.state.old_hours.sep_3}</td>
                          <td>
                            {this.myToFixed(this.computeSEP3Minutes() / 60)}{" "}
                            <span
                              className={
                                sep_3_old_hours_quantity_restriction.satisfies
                                  ? "correct"
                                  : "incorrect"
                              }
                            >
                              {" "}
                              {
                                sep_3_old_hours_quantity_restriction.printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {sep_3_old_hours_quantity_restriction.satisfies ? (
                              <i
                                className="fa fa-check correct"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times incorrect"
                                aria-hidden="true"
                              ></i>
                            )}
                          </td>
                        </tr>
                      </tbody>
                      <thead className="thead-light">
                        <tr>
                          <th>Cantidad Total Anterior</th>
                          <th>Cantidad Total Actual</th>
                          <th>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key="max_total_hours">
                          <td>
                            {this.state.old_hours.middle_classroom +
                              this.state.old_hours.high_classroom}
                          </td>
                          <td>
                            {this.myToFixed(
                              distributedClassroomMinutes.middle / 60 +
                                distributedClassroomMinutes.high / 60
                            )}
                            <span
                              className={
                                total_old_hours_quantity_restriction.satisfies
                                  ? "correct"
                                  : "incorrect"
                              }
                            >
                              {" "}
                              {
                                total_old_hours_quantity_restriction.printable_diff
                              }
                            </span>
                          </td>
                          <td>
                            {total_old_hours_quantity_restriction.satisfies ? (
                              <i
                                className="fa fa-check correct"
                                aria-hidden="true"
                              ></i>
                            ) : (
                              <i
                                className="fa fa-times incorrect"
                                aria-hidden="true"
                              ></i>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="centered-text flex flex-column">
                      <h5>Sobreescribir Horas</h5>
                      <div className="alert alert-warning h-25">
                        <strong>
                          Si se activa alguno de los valores, se reemplazaran
                          las horas puestas en el horario por ese valor
                        </strong>
                      </div>
                      <div className="form-group w-75 overwrite-input">
                        <label htmlFor="middle-classroom-overwrited-hours">
                          Horas Cronológicas Básica Final
                        </label>
                        <div className="flex space-around">
                          <div>
                            <input
                              value={this.state.overwrited_hours.middle}
                              type="number"
                              id="middle-classroom-overwrited-hours"
                              className="form-control"
                              name="middle"
                              onBlur={
                                this.checkOverwritedHoursInvalidNumberInput
                              }
                              onChange={this.handleOverwritedHoursInputChange}
                            ></input>
                          </div>
                          <div className="radio activate">
                            <label>
                              <input
                                type="checkbox"
                                id="middle-classroom-overwrited-hours"
                                name="middle"
                                value="true"
                                checked={this.state.overwrited.middle}
                                onChange={this.handleOverwritedChange}
                              />
                              Activar
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group w-75 overwrite-input">
                        <label htmlFor="high-classroom-overwrited-hours">
                          Horas Cronológicas Media Final
                        </label>
                        <div className="flex space-around">
                          <div>
                            <input
                              value={this.state.overwrited_hours.high}
                              type="number"
                              id="high-classroom-overwrited-hours"
                              className="form-control"
                              name="high"
                              onBlur={
                                this.checkOverwritedHoursInvalidNumberInput
                              }
                              onChange={this.handleOverwritedHoursInputChange}
                            ></input>
                          </div>
                          <div className="radio activate">
                            <label>
                              <input
                                type="checkbox"
                                name="high"
                                value="true"
                                checked={this.state.overwrited.high}
                                onChange={this.handleOverwritedChange}
                              />
                              Activar
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group w-75 overwrite-input">
                        <label htmlFor="sep-1-overwrited-hours">
                          Horas Cronológicas SEP 1 Final
                        </label>
                        <div className="flex space-around">
                          <div>
                            <input
                              value={this.state.overwrited_hours.sep_1}
                              type="number"
                              id="sep-1-overwrited-hours"
                              className="form-control"
                              name="sep_1"
                              onBlur={
                                this.checkOverwritedHoursInvalidNumberInput
                              }
                              onChange={this.handleOverwritedHoursInputChange}
                            ></input>
                          </div>
                          <div className="radio activate">
                            <label>
                              <input
                                type="checkbox"
                                name="sep_1"
                                value="true"
                                checked={this.state.overwrited.sep_1}
                                onChange={this.handleOverwritedChange}
                              />
                              Activar
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group w-75 overwrite-input">
                        <label htmlFor="sep-2-overwrited-hours">
                          Horas Cronológicas SEP 2 Final
                        </label>
                        <div className="flex space-around">
                          <div>
                            <input
                              value={this.state.overwrited_hours.sep_2}
                              type="number"
                              id="sep-2-overwrited-hours"
                              className="form-control"
                              name="sep_2"
                              onBlur={
                                this.checkOverwritedHoursInvalidNumberInput
                              }
                              onChange={this.handleOverwritedHoursInputChange}
                            ></input>
                          </div>
                          <div className="radio activate">
                            <label>
                              <input
                                type="checkbox"
                                name="sep_2"
                                value="true"
                                checked={this.state.overwrited.sep_2}
                                onChange={this.handleOverwritedChange}
                              />
                              Activar
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group w-75 overwrite-input">
                        <label htmlFor="sep-3-overwrited-hours">
                          Horas Cronológicas SEP 3 Final
                        </label>
                        <div className="flex space-around">
                          <div>
                            <input
                              value={this.state.overwrited_hours.sep_3}
                              type="number"
                              id="sep-3-overwrited-hours"
                              className="form-control"
                              name="sep_3"
                              onBlur={
                                this.checkOverwritedHoursInvalidNumberInput
                              }
                              onChange={this.handleOverwritedHoursInputChange}
                            ></input>
                          </div>
                          <div className="radio activate">
                            <label>
                              <input
                                type="checkbox"
                                name="sep_3"
                                value="true"
                                checked={this.state.overwrited.sep_3}
                                onChange={this.handleOverwritedChange}
                              />
                              Activar
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="restriction">
                    <h4>Máximo de Horas Cronológicas Semanales</h4>
                    <table className="table table-striped table-hover centered-text">
                      <thead className="thead-light">
                        <tr>
                          <th>Máximo de Horas</th>
                          <th>Horas Totales</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key="max_hours">
                          <td>44</td>
                          <td>
                            {this.myToFixed(
                              this.state.total_minutes_final / 60
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="salary-container">
                <div className="salary">
                  <h2>Sueldo</h2>
                  <table className="salary-table table table-hover ">
                    <thead className="thead-light">
                      <tr>
                        <th>Item</th>
                        <th>Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="header-row">
                        <td>Haberes Imponibles</td>
                        <td></td>
                      </tr>
                      <tr key="base">
                        <td>
                          Base ({salary.taxable.base.middle_hours} AB -{" "}
                          {salary.taxable.base.high_hours} AM)
                        </td>
                        <td>${salary.taxable.base.salary.toLocaleString()}</td>
                      </tr>
                      <tr key="sep 1">
                        <td>SEP 1 ({salary.taxable.sep_1.hours})</td>
                        <td>${salary.taxable.sep_1.salary.toLocaleString()}</td>
                      </tr>
                      <tr key="sep 2">
                        <td>SEP 2 ({salary.taxable.sep_2.hours})</td>
                        <td>${salary.taxable.sep_2.salary.toLocaleString()}</td>
                      </tr>
                      <tr key="sep 3">
                        <td>SEP 3 ({salary.taxable.sep_3.hours})</td>
                        <td>${salary.taxable.sep_3.salary.toLocaleString()}</td>
                      </tr>
                      <tr key="brp_titulo">
                        <td>
                          Bono BRP Título ({salary.taxable.brp_titulo.hours})
                        </td>
                        <td>
                          ${salary.taxable.brp_titulo.salary.toLocaleString()}
                        </td>
                      </tr>
                      <tr key="brp_mencion">
                        <td>
                          Bono BRP Mención ({salary.taxable.brp_mencion.hours})
                        </td>
                        <td>
                          ${salary.taxable.brp_mencion.salary.toLocaleString()}
                        </td>
                      </tr>
                      <tr key="ley">
                        <td>
                          Bono pro ley 19410-19933 ({salary.taxable.ley.hours})
                        </td>
                        <td>${salary.taxable.ley.salary.toLocaleString()}</td>
                      </tr>
                      <tr key="ley_pie">
                        <td>
                          Bono pro ley 19410-19933 PIE (
                          {salary.taxable.ley_pie.hours})
                        </td>
                        <td>
                          ${salary.taxable.ley_pie.salary.toLocaleString()}
                        </td>
                      </tr>
                      <tr className="sum-row" key="sum">
                        <td>
                          <strong>Total Imponible</strong>
                        </td>
                        <td>
                          $
                          {Object.values(salary.taxable)
                            .map((item) => item.salary)
                            .reduce((a, b) => a + b)
                            .toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr className="header-row">
                        <td>Haberes No Imponibles</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>Movilización</td>
                        <td>
                          ${salary.non_taxable.movilization.toLocaleString()}
                        </td>
                      </tr>
                      <tr className="sum-row">
                        <td>
                          <strong>Total No Imponible</strong>
                        </td>
                        <td>
                          $
                          {Object.values(salary.non_taxable)
                            .reduce((a, b) => a + b)
                            .toLocaleString()}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr className="final-sum-row">
                        <td>
                          <strong>Líquido</strong>
                        </td>
                        <td>
                          $
                          {(
                            Object.values(salary.non_taxable).reduce(
                              (a, b) => a + b
                            ) +
                            Object.values(salary.taxable)
                              .map((item) => item.salary)
                              .reduce((a, b) => a + b) *
                              0.8
                          ).toLocaleString()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <ProtectedPage
              setComments={this.setComments}
              info={this.state}
              setExtraHours={this.setExtraHours}
              setNewSepValues={this.setNewSepValues}
            />
          </TabPanel>
        </Tabs>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    contractInfo: JSON.parse(JSON.stringify(state.contractInfo)),
    teacherInfo: JSON.parse(JSON.stringify(state.teacherInfo)),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setContractInfoState: (contractInfo) => {
      dispatch({
        type: "SET CONTRACT INFO",
        contractInfo: contractInfo,
      });
    },
    resetContractInfo: () => {
      dispatch({
        type: "RESET CONTRACT INFO",
      });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/home/HomePage.js